import React, { Component, createRef } from "react";

import Form from "react-bootstrap/Form";
import Select from "react-select";
import {
    preventNonDigitCharacters,
   } from "../../utils/common";
import { v4 as uuidv4 } from 'uuid';
import QRCode from 'qrcode.react';
import { Row, Col, Container, Button, Nav, Tab, Modal } from "react-bootstrap";
import { getCookies,setCookie } from "../../utils/cookies";
import { withTranslation } from "react-i18next";
import GoogleCaptcha from "../common/GoogleCaptcha";
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import validator from "validator";
import Checkbox from "../common/Checkbox";
import SystemDownTime from "../common/SystemDownTime";
import queryString from "query-string";
import i18n from "../../i18n";
import RightArrow from "../../assets/images/right-arrow-white.svg";
import Phone from  "../../assets/images/mobile-img.svg";
import Card from "../../assets/images/id-card.svg";
import Loading from  "../../assets/images/loading.svg";
import Tick from "../../assets/images/tick.svg";
import Notick from "../../assets/images/failure.png";
import Carousel1 from "../../assets/images/MFA-Background-001.png";
import Carousel2 from "../../assets/images/MFA-Background-002.png";
import Carousel3 from "../../assets/images/MFA-Background-003.png";
import Carousel4 from "../../assets/images/MFA-Background-004.png";
import Carousel5 from "../../assets/images/MFA-Background-005.png";
import Carousel6 from "../../assets/images/MFA-Background-006.png";
import Carousel7 from "../../assets/images/MFA-Background-007.png";
import Carousel9 from "../../assets/images/reg9.jpg";
import Logo from "../../assets/images/CT-logo.svg";
import downChevron from "../../assets/images/down-chevron.svg";
import WithError from "../common/WithError";

class IdVerification extends Component {
    constructor(props) {
        super(props);
        this.verificationInputRef = React.createRef();
        this.state = {
          isNameDisabled: false,
          nameDirty: false,
          givenName: "",
          sn: "",
          mail: "",
          dateOfBirth: "",
          socialNumber : "",
          address1: "",
          city: "",
          states: "",
          country:"",
          zipCode : "",
          address2: "",
          errorText: "",
		      htmlError: '',
          errorArray: [],
          formSubmitted: false,
          rejectStatus: false,
          captchaReset: false,
          showPassword: false,
          regButton: false,
          disableSMSButton: false,
          startTransaction: false,
          loading: true, 
          language:"en_US",
          availableLanguages:["en_US", "es"],
          selectedOption:getCookies("ctsessionlanguage") || "en_US",   
          tickImage: [{'image': Tick},{'image': Notick}],
          carouselImages: [{'image':Carousel1},{'image':Carousel2},{'image':Carousel3},{'image':Carousel4},{'image':Carousel5},{'image':Carousel6},{'image':Carousel7},{'image':Carousel9}],
          imageIndex: 0,
          telephoneNumber: "",
          mobileNo: "",
          screen:0,
          documentStep:1,
          rightScreen:0,
          numberFocus:false,
          seeMore:false,
          consent : false,
          ipAddress : '',      
          paramState: "",
          disableCaptcha: true,
          captchaReset: false,
          googleCaptchaToken: "",
          googleCaptchaResponse: "",
          optionsUS : [
              { value: 'AL', label: 'Alabama (AL)' },
              { value: 'AK', label: 'Alaska (AK)' },
              { value: 'AZ', label: 'Arizona (AZ)' },
              { value: 'AR', label: 'Arkansas (AR)' },
              { value: 'AS', label: 'American Samoa (AS)' },
              { value: 'CA', label: 'California (CA)' },
              { value: 'CO', label: 'Colorado (CO)' },
              { value: 'CT', label: 'Connecticut (CT)' },
              { value: 'DE', label: 'Delaware (DE)' },
              { value: 'DC', label: 'District of Columbia (DC)' },
              { value: 'FL', label: 'Florida (FL)' },
              { value: 'GA', label: 'Georgia (GA)' },
              { value: 'GU', label: 'Guam (GU)' },
              { value: 'HI', label: 'Hawaii (HI)' },
              { value: 'ID', label: 'Idaho (ID)' },
              { value: 'IL', label: 'Illinois (IL)' },
              { value: 'IN', label: 'Indiana (IN)' },
              { value: 'IA', label: 'Iowa (IA)' },
              { value: 'KS', label: 'Kansas (KS)' },
              { value: 'KY', label: 'Kentucky (KY)' },
              { value: 'LA', label: 'Louisiana (LA)' },
              { value: 'ME', label: 'Maine (ME)' },
              { value: 'MD', label: 'Maryland (MD)' },
              { value: 'MA', label: 'Massachusetts (MA)' },
              { value: 'MI', label: 'Michigan (MI)' },
              { value: 'MN', label: 'Minnesota (MN)' },
              { value: 'MS', label: 'Mississippi (MS)' },
              { value: 'MO', label: 'Missouri (MO)' },
              { value: 'MT', label: 'Montana (MT)' },
              { value: 'NE', label: 'Nebraska (NE)' },
              { value: 'NV', label: 'Nevada (NV)' },
              { value: 'NH', label: 'New Hampshire (NH)' },
              { value: 'NJ', label: 'New Jersey (NJ)' },
              { value: 'NM', label: 'New Mexico (NM)' },
              { value: 'NY', label: 'New York (NY)' },
              { value: 'NC', label: 'North Carolina (NC)' },
              { value: 'ND', label: 'North Dakota (ND)' },
              { value: 'MP', label: 'Northern Mariana Islands (MP)' },
              { value: 'OH', label: 'Ohio (OH)' },
              { value: 'OK', label: 'Oklahoma (OK)' },
              { value: 'OR', label: 'Oregon (OR)' },
              { value: 'PA', label: 'Pennsylvania (PA)' },
              { value: 'PR', label: 'Puerto Rico (PR)' },
              { value: 'RI', label: 'Rhode Island (RI)' },
              { value: 'SC', label: 'South Carolina (SC)' },
              { value: 'SD', label: 'South Dakota (SD)' },
              { value: 'TN', label: 'Tennessee (TN)' },
              { value: 'TX', label: 'Texas (TX)' },
              { value: 'UT', label: 'Utah (UT)' },
              { value: 'VT', label: 'Vermont (VT)' },
              { value: 'VA', label: 'Virginia (VA)' },
              { value: 'VI', label: 'Virgin Islands (VI)' },
              { value: 'WA', label: 'Washington (WA)' },
              { value: 'WV', label: 'West Virginia (WV)' },
              { value: 'WI', label: 'Wisconsin (WI)' },
              { value: 'WY', label: 'Wyoming (WY)' }
          ], 
          optionsMX: [
              {value:'AG', label :'AG'},
                {value:'BN', label :'BN'},
                {value:'BS', label :'BS'},
                {value:'CH', label :'CH'},
                {value:'CI', label :'CI'},
                {value:'CL', label :'CL'},
                {value:'CP', label :'CP'},
                {value:'CS', label :'CS'},
                {value:'DF', label :'DF'},
                {value:'DG', label :'CG'},
                {value:'GE', label :'GE'},
                {value:'GJ', label :'GJ'},
                {value:'HD', label :'HD'},
                {value:'JA', label :'JA'},
                {value:'MC', label :'MC'},
                {value:'MR', label :'MR'},
                {value:'MX', label :'MX'},
                {value:'NA', label :'NA'},
                {value:'NL', label :'NL'},
                {value:'OA', label :'OA'},
                {value:'PU', label :'PU'},
                {value:'QE', label :'QE'},
                {value:'QI', label :'QI'},
                {value:'SI', label :'SI'},
                {value:'SL', label :'SL'},
                {value:'SO', label :'SO'},            
                {value:'TA', label :'TA'},
                {value:'TB', label :'TB'},
                {value:'TL', label :'TL'},
                {value:'VC', label :'VC'},
                {value:'YU', label :'YU'},            
                {value:'ZA', label :'ZA'}
          ],
          optionsCA:[
                {value:'AB', label :'AB'},
                {value:'BC', label :'BC'},
                {value:'MB', label :'MB'},
                {value:'NB', label :'NB'},
                {value:'NL', label :'NL'},
                {value:'NT', label :'NT'},
                {value:'NS', label :'NS'},
                {value:'NU', label :'NU'},
                {value:'ON', label :'ON'},
                {value:'PE', label :'PE'},
                {value:'QC', label :'QC'},
                {value:'SK', label :'SK'},
                {value:'YT', label :'YT'}
          ],
          cityOptions : [{label:'United States of America', value :'US'},
            {label:'Canada', value :'CA'},
            {label:'Mexico', value :'MX'},
          ],
          stateOptions: [],
          dialCode: '',
          selectedNumber: '',
          QRLink : '',
          questionsArray : [],
          questionId : '',
          token : '',
          smsSent : false,
          resendSMS : true,
          referencePayload: {},
          verificationPayload : {},
          linkPayload : {},
          smsPayload: {},
          smsResponsePayload: {},
          smsResendPayload: {},
          pollingPayload: {},
          qnaPayload: {},
          trueIDPayload: {},
          showPopup: false,
          showCancelPopup: false,
          selectedTab : "QR",
          sessionId: '',
          showDescriptive: true,
          todayDate: new Date().toISOString().split('T')[0],
          isSystemError: false,
          showScreen : true,
          refID : '',
          goto : ''
        };

        this.selectedQuestions = [];
        this.idleTimeout = null;
        this.selectOpened = false;
        this.blurTimeout = null;
  
    }

    componentDidMount() {
      let keysToRemove = ["lnTransactionId", "authSelectionId"];

      keysToRemove.forEach(k =>
        localStorage.removeItem(k))


      if(getCookies('ctsessionlanguage')) {
          this.setState({ selectedOption : getCookies('ctsessionlanguage')});
      }

      //Function to get user's IP from base service
      //Fallback to FR if base service is blocked/inaccessible
      const getPublicIP = async() => {
        const services = [
          'https://api.ipify.org?format=json'
        ];
        const locationUrl = window.location.origin;

        if (locationUrl.indexOf('dev.login.ct.gov') > 0) {
          services.push('https://dev.account.ct.gov/openidm/endpoint/get-ip');
        } 
        else if (locationUrl.indexOf('stg.login.ct.gov') > 0) {
          services.push('https://stg.account.ct.gov/openidm/endpoint/get-ip'); 
        } 
        else if (locationUrl.indexOf('devc.login.ct.gov') > 0) {
           services.push('https://devc.account.ct.gov/openidm/endpoint/get-ip'); 
        } 
        else if (locationUrl.indexOf('psup.login.ct.gov') > 0) {
           services.push('https://psup.account.ct.gov/openidm/endpoint/get-ip');   
        } 
        else {
          services.push('https://account.ct.gov/openidm/endpoint/get-ip'); 
        }

        for(let url of services) {
          try {
            const response = await fetch(url, {
              method: 'GET',
			        headers: {
			        	'Accept': 'application/json'
			        }
            });
            if(!response.ok) continue;
		
		        const data = await response.json();

		        return data.ip || data.address || data.ip_address;
          } catch (e){
            continue;
          }
        }
        throw new Error('Failed to retrieve public IP');
      };

      //Call the function & set the variable in the state
      getPublicIP()
        .then(ip => {
          console.log('IP:', ip);
          this.setState({ ipAddress: ip });
        })
        .catch(err => {
          console.error('Error fetching IP:', err);
        });

      let queryParam = new URLSearchParams(window.location.search);
      let refId = queryParam.get('refId');
      let goto = queryParam.get('goto');
      let URLState = queryParam.get('state');
      let session = uuidv4();

      if (refId) {
        this.setState({
            refID: refId,
          });
      } else {
          this.setState({
            screen: 11,
            startTransaction: true,
          });
      }
      
      if (goto) {
        this.setState({
            goto: goto,
          });
      } else {
          this.setState({
            screen: 11,
            startTransaction: true,
          });
      }
      
      this.setState({    
          paramState: URLState,
          sessionId: session
      });

      if(!this.hasInitialReponse)
        this.handleResponse(); 
    }

    componentDidUpdate(prevState, prevProps){
      
      const langP = i18n.language || "en_US";
      if(this.state.selectedOption !== langP){
        this.setState({
          selectedOption:langP
        })
      }
      if(this.state.screen === 5 && this.state.selectedTab !== "SMS") 
      {
        this.startIdleTimer();
      }
    }

    componentWillUnmount(){
      this.clearIdleTimer();
    }
	
	  fetchDOMElement = () => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(this.state.htmlError, 'text/html');
        const pTags = Array.from(doc.getElementsByTagName('p')).map(p => p.textContent);
        this.setState({
            htmlError:pTags,
            screen: 12
          })
    }

    seeMoreHandler = () => {
      this.setState({
        seeMore: !this.state.seeMore,
      });
    };

    startIdleTimer = () => {
      this.clearIdleTimer();
      this.idleTimeout = setTimeout(()=> {
        this.setState({
            showPopup: true
        });
      }, 120000);
    }
    clearIdleTimer = () => {
      if(this.idleTimeout) {
        clearTimeout(this.idleTimeout);
      }
    }

    handleClosePopup = () => {
      this.setState({ showPopup : false });
      this.startIdleTimer();
    }

    displayClosePopup = () => {
      this.setState({ showCancelPopup: true});
    }

    hideClosePopup  = () => {
      this.setState({ showCancelPopup: false});
    }

    handleLanguageChange  = (e) => {
      i18n.changeLanguage(e.value);
      setCookie("ctsessionlanguage", e.value);
      this.setState({
        selectedOption: e.value
      });
      let environment;
      const locationUrl = window.location.origin;
      if (locationUrl.indexOf('dev.login.ct.gov') > 0) {
        environment = 'ctapproutedev';
      } else if (locationUrl.indexOf('stg.login.ct.gov') > 0) {
        environment = 'ctapproutestg';
      } else if (locationUrl.indexOf('devc.login.ct.gov') > 0) {
        environment = 'ctapproutedevc';
      } else if (locationUrl.indexOf('psup.login.ct.gov') > 0) {
        environment = 'ctapproutepsup';    
      } else if (locationUrl.indexOf('login.ct.gov') > 0) {
        environment = 'ctapproute';
      }
      const ctapproute = getCookies(`${environment}`);
      if (ctapproute && ctapproute.includes("language")) {
        const urlArray = `?${ctapproute.split("?")[1]}`;
        const params = queryString.parse(urlArray);
        params.language = e.value;
        const url = `?${decodeURIComponent(queryString.stringify(params))}`;
        setCookie(`${process.env.environment}`, url);
      }
    }

    getDefaultTextByPrompt = (callbacks = [], prompt) => {
      const cb = callbacks.find(
        (c) =>
          c?.type === "TextInputCallback" &&
          (c.output || []).some((o) => o?.name === "prompt" && o?.value === prompt)
      );
      const val = (cb?.output || []).find((o) => o?.name === "defaultText")?.value;
      return (val ?? "").toString();
    };

    hasTextOutputMessage = (callbacks = [], message) =>
      callbacks.some(
        (c) =>
          c?.type === "TextOutputCallback" &&
          (c.output || []).some((o) => (o?.value ?? "") === message)
      );
      
    handleResponse = () => {
      let payload = this.state.referencePayload;
      let refId = this.state.refID;
      let goto = this.state.goto;
      let referrer =  document.referrer ? new URL(document.referrer).origin : '';
      if(Object.keys(payload).length !== 0) {
        payload.callbacks[1].input[0].value = refId;
         payload.callbacks[2].input[0].value = goto ?  goto : "";
         payload.callbacks[3].input[0].value = referrer;
      }
      let url = this.getEndPoint() + '?service=IDVerificationLevel1&authIndexType=service&authIndexValue=IDVerificationLevel1';
      fetch(url, {
        method: 'POST',
        mode: 'cors',
        headers: {
          "Accept": '*/*',
          "Accept-API-Version": "protocol=1.0,resource=2.1",
          "Content-Type" : "application/json"
        },
        body: payload ? JSON.stringify(payload) : "",
      }) 
      .then(response => {
          let responseStatus = response.status ? response.status : response.code;
          if (responseStatus === 404 || responseStatus === 401 || responseStatus === 500 || responseStatus === 400) {
            //error screen
              this.setState({
                loading: false,
                screen: 11,
                startTransaction: true,
              });
          }   
          if(responseStatus === 503) {
            let result = { responseCode: 503 }
            this.handleErrorResponse(result);
          }
          const contentType = response.headers.get('content-type');
          if(responseStatus === 200) {
            if(contentType && contentType.includes('text/html')) {
              return response.text().then((body) => {
                //error screen
                  this.setState({
                    htmlError: body,
                    loading: false,
                  });
                this.fetchDOMElement()
              });
            }
            else {
              return response.json().then((data) => {
                const isPayload =
                  (data &&
                    data.callbacks?.[1]?.output?.[0]?.value ===
                    "ID_VERIFICATION_PAYLOAD") ||
                  data.callbacks?.[0]?.output?.[0]?.value === "ID_VERIFICATION_PAYLOAD";

                if (isPayload) {
                  const firstName = this.getDefaultTextByPrompt(data.callbacks, "FIRST_NAME").trim();
                  const lastName = this.getDefaultTextByPrompt(data.callbacks, "LAST_NAME").trim();

                  const hasPrefilledName = firstName.length > 0 || lastName.length > 0;
                  const editableName = this.hasTextOutputMessage(data.callbacks, "NM_EDIT_1");

                  const isNameDisabled = hasPrefilledName && !editableName;

                  this.setState((prev) => ({
                    verificationPayload: data,
                    loading: false,
                    screen: 2,
                    rightScreen: 2,
                    country: this.state.cityOptions[0],
                    stateOptions: this.state.optionsUS,
                    givenName: firstName,
                    sn: lastName,

                    isNameDisabled
                  }));
                   this.loadScript()
                      if (data.callbacks[0].type === 'ReCaptchaCallback') {
                        const recaptchaSiteKey = data.callbacks[0].output[0].value;
                        if (recaptchaSiteKey) {
                          this.setState({
                          googleCaptchaToken: recaptchaSiteKey,
                          disableCaptcha : false,
                          });
                        } 
                      }                    
                      this.hasInitialReponse = true;
                } else if (data && data.callbacks[1].output[0].value === 'ID_VERIFICATION_PAYLOAD' || data.callbacks[0].output[0].value === 'ID_VERIFICATION_PAYLOAD') {
                  this.setState({
                        verificationPayload: data,
                        loading: false,
                        screen: 2,
                        rightScreen: 2,
                        //setting US as default country
                        country: this.state.cityOptions[0],
                        stateOptions : this.state.optionsUS
                      });
                      this.loadScript()
                      if (data.callbacks[0].type === 'ReCaptchaCallback') {
                        const recaptchaSiteKey = data.callbacks[0].output[0].value;
                        if (recaptchaSiteKey) {
                          this.setState({
                          googleCaptchaToken: recaptchaSiteKey,
                          disableCaptcha : false,
                          });
                        } 
                      }                    
                      this.hasInitialReponse = true;
                  }
                  else if(data && data.callbacks[0].output[0].value === "REFERENCE_DETAILS") {
                    //reference
                     this.setState({
                      referencePayload: data
                    });
                    this.handleResponse();
                  }
                  else if (data && data.callbacks[0].output[0].value  === "VERIFICATION_RESULT_ERROR") {
                    const result_value = data.callbacks[1].output[0].value; 
                    this.handleErrorResponse(result_value);
                   }
              });
            }
          }
      });
    }
    

    handleErrorResponse = (result_value) => {
        //handling error scenario
        let error_code, redirectURL;
        if(result_value.responseCode) {
          switch(true) {
            case result_value.responseCode === 400:
            case (result_value.responseCode >= 404 && result_value.responseCode <= 499):
              error_code =  "BAD_REQUEST";
              break;
            case result_value.responseCode === 401:
            case result_value.responseCode === 403:
            case (result_value.responseCode >= 500 && result_value.responseCode <= 599):
              error_code = "SYSTEM_ERROR";
              break;
            case result_value.responseCode === "CANCEL":
              error_code = "CANCEL";
              break;
            default:
              error_code = "UNKNOWN_ERROR";
              break;
          }
        }
        let goto = this.state.goto;
        let refID = this.state.refID;
        if((result_value.status === "COMPLETE" || result_value.redirect === "true") && (result_value.status !== "ERROR")) {
            redirectURL = goto + "?status=" + result_value.status ;
            if(result_value.verificationHash) {
              redirectURL +=  `&verId=${result_value.verificationHash}`;
            }
            if(result_value.verificationResult) {
               redirectURL +=  `&verificationResult=${result_value.verificationResult}`;
            }
            if(result_value.refId) {
               redirectURL +=  `&refId=${result_value.refId}`;
            }
            else  {
              redirectURL +=  `&refId=` + refID ;
            }
            window.location.href = redirectURL;
        }
        else if(result_value.status === "ERROR" && result_value.redirect === "true") {
            redirectURL = goto + "?status=" + result_value.status ;
            if(result_value.responseCode) {
              redirectURL +=  `&error=${error_code}`;
            }
            if(result_value.refId) {
              redirectURL +=  `&refId=${result_value.refId}`;
            }
            else  {
              redirectURL +=  `&refId=` + refID ;
            }
            window.location.href = redirectURL;
        }
        else if(result_value.status === "ERROR" && result_value.redirect === "false") {  
            //error screen
            this.setState({
              loading: false,
              screen: 11,
              startTransaction: true,
            });
        }
        else if(result_value.responseCode) {
          //general case of error
           if(result_value.responseCode === 503) {
              this.setState({
                  isSystemError : true,
                  showScreen : false,
                  loading: false
              });
           }
           else {
              redirectURL =  this.state.goto + "?status=ERROR&error=" + error_code;
              if(result_value.refId) {
                redirectURL +=  `&refId=${result_value.refId}`;
              }
              else  {
                redirectURL +=  `&refId=` + refID ;
              }
              window.location.href = redirectURL;
           }
        }
    }

    redirectOnCancel = () => {
      let result_value = {
            responseCode  : "CANCEL"
        } 
      this.handleErrorResponse(result_value);
    }

    getLinkData = (e) => {
      e.preventDefault();
      let button = e.currentTarget;
      button.disabled = true;
      let url = this.getEndPoint() + '?service=IDVerificationLevel2&authIndexType=service&authIndexValue=IDVerificationLevel2';
      fetch(url, {
        method: 'POST',
        mode: 'cors',
        headers: {
          "Accept": '*/*',
          "Accept-API-Version": "protocol=1.0,resource=2.1",
        }
      }) 
      .then(response => {
          button.disabled = false;
          let responseStatus = response.status ? response.status : response.code;
          if (responseStatus !== 200) {
            let result_value = {
                responseCode  : response.status ? response.status : response.code
            } 
            this.handleErrorResponse(result_value);
          }
          const contentType = response.headers.get('content-type');
          if(responseStatus === 200) {
            if(contentType && contentType.includes('text/html')) {
              return response.text().then((body) => {
                //error screen
                  this.setState({
                  htmlError: body
                  });
                this.fetchDOMElement()
              });
            }
            else {
              return response.json().then((data) => {
                if (data && data.callbacks[0].output[0].value === 'GENERATE_LINK') {
                  this.setState({
                    linkPayload: data
                  });
                  this.moveNextPage();
                }
                else if(data.callbacks[0].output[0].value === "VERIFICATION_RESULT_ERROR") {
                    const result_value = data.callbacks[1].output[0].value; 
                    this.handleErrorResponse(result_value);
                }
              }); 
            }
         }         
        else {
          throw new Error("Unsupported content" + contentType)
        }
        });
    }
    

    getLowerCaseParam = (params) => {
        const paramMap = {};

        for(const [key, value] of params.entries()) {
          paramMap[key.toLowerCase()] = value;
        }
        return paramMap;
    }

    showPassword = () => {
      this.setState((prevState) => ({
        showPassword: !prevState.showPassword,
      }));
    }

    HandleEnterKey = (e) => {
      if (e.keyCode === 13) {
        this.setState((prevState) => ({
          showPassword: !prevState.showPassword,
        }));
      }
    };

    getEndPoint = () => {
      let appEndpoint;
      const locationUrl = window.location.origin;
      if (locationUrl.indexOf('dev.login.ct.gov') > 0) {
        appEndpoint = 'https://dev.login.ct.gov/openam/json/realms/root/realms/boscitizens/authenticate';    
      } else if (locationUrl.indexOf('stg.login.ct.gov') > 0) {
          appEndpoint = 'https://stg.login.ct.gov/json/realms/root/realms/boscitizens/authenticate';
      } else if (locationUrl.indexOf('devc.login.ct.gov') > 0) {
        appEndpoint = 'https://devc.login.ct.gov/json/realms/root/realms/boscitizens/authenticate';
      } else if (locationUrl.indexOf('psup.login.ct.gov') > 0) {
        appEndpoint = 'https://psup.login.ct.gov/json/realms/root/realms/boscitizens/authenticate';    
      } else if (locationUrl.indexOf('login.ct.gov') > 0) {
        appEndpoint = 'https://login.ct.gov/json/realms/root/realms/boscitizens/authenticate';    
      }
      return appEndpoint;
    }

    loadScript = () => {
      var ele = document.createElement("script");
      ele.type="text/javascript";
      ele.src= process.env.PUBLIC_URL + "/bits_toolkit.js";
      ele.onload = () => {
        this.initializeLibrary();
      }
      ele.onerror = () => {
        console.error("failed script");
      }
      document.head.appendChild(ele);
    }

    initializeLibrary = () => {
      var elem = document.createElement("script");
      const sessionId = this.state.sessionId;
      let pageNumber, org_id;
      const locationUrl = window.location.origin;
      if (locationUrl.indexOf('dev.login.ct.gov') > 0) {
        pageNumber = 2;  
        org_id = "1947p33v" 
      } else if (locationUrl.indexOf('stg.login.ct.gov') > 0) {
          pageNumber = 4;
        org_id = "1947p33v" 
      } else if (locationUrl.indexOf('devc.login.ct.gov') > 0) {
        pageNumber = 3;
        org_id = "1947p33v" 
      }
      else {
        pageNumber = 2;
        org_id = "e08ipn25"
      }
      elem.type="text/javascript";
      elem.innerHTML = "verification.profile(\"login3.ct.gov\", \"" + org_id + "\", \"" + sessionId + "\", \"" + pageNumber + "\");"
      document.body.appendChild(elem);
    }

    isFormFieldValid = (e, key) => {
      let value;
      value = e.target ? e.target.value : e;
      if(key == "dateOfBirthError" && value != '')
      {
        value = this.convertDOBPicker(value, 1);
      }

      let errorMsg = "";
      switch (key) {
        case "givenNameError":
          if (value.length <= 0 || (/^\s*$/.test(value))) {
            errorMsg = "common.errors.firstNameError";
          }
          break;
        case "snError":
          if (value.length <= 0 || (/^\s*$/.test(value))) {
            errorMsg = "common.errors.lastNameError";
          }
          break;
        case "emailError":
          value = e.target ? e.target.value.trim() : e;
          if (
            value.length <= 0 ||
            !value.match(
              /(^$|^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$)/
            )
          ) {
            errorMsg = "common.errors.emailError";
          }
          break;
        case "dateOfBirthError":
            let now = new Date();
            const mm = String(now.getMonth() + 1).padStart(2, '0'); // Month is 0-indexed
            const dd = String(now.getDate()).padStart(2, '0');
            const yyyy = now.getFullYear();
            let formattedDate = `${mm}/${dd}/${yyyy}`;
            let date1 = new Date(value);
            let date2 = new Date(formattedDate);
            if (value.length <= 0) {
              errorMsg = "common.errors.dateOfBirthReqd";
            } else if (
              !/^\d{2}\/\d{2}\/\d{4}$/.test(value) ||
              !validator.isDate(value, { format: "mm/dd/yyyy" })
            ) {
              errorMsg = "common.errors.dateOfBirthFormat";
            }
            else if (date1 > date2) {
              errorMsg = "common.errors.dateOfBirthFuture";
            }
          break;
        case "ssnError":
              if (value.length < 1) {
                errorMsg = "common.errors.ssnError";
              } else  if (value.length !== 11) {
                errorMsg = "common.errors.ssnDigitError";
              }
          break;
        case "phoneError":
              let formattedNumber = value.match(/^\s*(\+\d{1,4})[\s\-()]*([\d\s\-()]+)/)[2].replace(/\D/g, '');
              const pattern = /^[1-9][0-9]{9}$/;
              if (formattedNumber.length != 10) {
                this.setState({
                  telephoneNumberError:  "pages.editNumberPopup.mobileNumberInvalid"
                });
                errorMsg = "pages.editNumberPopup.mobileNumberInvalid";
              }  
              else if(!pattern.test(formattedNumber)) {
                  this.setState({
                      telephoneNumberError:  "pages.editNumberPopup.invalidNumber"
                  });
                  errorMsg = "pages.editNumberPopup.invalidNumber";
              }
              else {
                this.setState({
                  telephoneNumberError:  ""
                });
              }
          break;
        case "mobileNumberError":           
          const numberPattern = /^[1-9][0-9]{9}$/;
              if (value.length != 10) {
                this.setState({
                  telephoneNumberError:  "pages.editNumberPopup.mobileNumberInvalid"
                });
                errorMsg = "pages.editNumberPopup.mobileNumberInvalid";
              }  
              else if(!numberPattern.test(value)) {
                  this.setState({
                      telephoneNumberError:  "pages.editNumberPopup.invalidNumber"
                  });
                  errorMsg = "pages.editNumberPopup.invalidNumber";
              }
              else {
                this.setState({
                  telephoneNumberError:  ""
                });
              }
          break;
        case "addressOneError":
          const addressPattern = /^[a-zA-Z0-9',.\-`&\/# ]*$/;
          if(value === "" || (!addressPattern.test(value)))
          {
            this.setState({
              addressOneError: "pages.idVerification.addressValid"
            })
            errorMsg = "pages.idVerification.addressValid";
          }
          break;
        case "addressTwoError":
          if(value === "" || (!addressPattern.test(value)))
          {
            this.setState({
              addressTwoError: "pages.idVerification.addressValid"
            })
            errorMsg = "pages.idVerification.addressValid";
          }
          break;
        case "stateError":
            if(value === "")
            {
              //if(this.state.states !== "") {                  
                  this.setState({
                    stateError: "pages.idVerification.stateValid"
                  })
                  errorMsg = "pages.idVerification.stateValid";
             /*  }
              else {
                this.setState({
                    stateError: "pages.idVerification.countryForState"
                  })
                  errorMsg = "pages.idVerification.countryForState";
              } */
            }
            else {
              errorMsg = "";
            }
            break;
        case "cityError":
            if(value === "")
            {
              this.setState({
                cityError: "pages.idVerification.cityValid"
              })
              errorMsg = "pages.idVerification.cityValid";
            }
            break;
        case "zipError":
              const exp = /^[a-zA-Z0-9 ]{5,7}$/;
              if(value === "" || !(exp.test(value)))
              {
                this.setState({
                  zipError: "pages.idVerification.zipCodeValid"
                })
                errorMsg = "pages.idVerification.zipCodeValid";
              }
              break;
        case "countryError":
                if(value === "")
                {
                  this.setState({
                    countryError: "pages.idVerification.countryValid"
                  })
                  errorMsg = "pages.idVerification.countryValid";
                }
                break;
        default:
          errorMsg = "";
          break;
      }
      this.setState({
        [key]: errorMsg
      });
      return errorMsg;
    };

    onFirstAndLastNameChange = (e, key) => {
      const value = e.target.value;
      this.setState({ nameDirty: true, [key]: value });

      const ok = /^[a-zA-Z '`,.\-]*$/.test(value);
      this.setState({ [`${key}Error`]: ok ? "" : "Invalid characters" });
    };

    onAddressHandler = (e, key) => {
      const {
        target: { value }
      } = e;
      if(e !== "")
      {
        this.setState({
          [key]: value
        });
      }
    }

    handleFocus = (key) => {
        this.selectOpened = true;
        let targetId = key.currentTarget.id;

        this.blurTimeout = setTimeout(() => {
          if(targetId === 'country') {
            if(this.selectOpened && this.state.country === '') {
              this.isFormFieldValid(this.state.country, 'countryError');
            }
          }
          else {
            if(this.selectOpened && this.state.states === '') {
              this.isFormFieldValid(this.state.states, 'stateError');
            }
          }
        }, 500)
    }

    onStateHandler = (e, key) => {
      if(e.value !== "")
      {
        this.setState({ [key] : e});
        if(key === "country") {          
           this.setState({ countryError: "", states : ""});
        }
        else {
          this.setState({stateError: ""});
        }
      }
      if(key === "country") {
          if(e.value === "US") {
            this.setState({ stateOptions : this.state.optionsUS});
          }else if(e.value === "CA") {
            this.setState({ stateOptions : this.state.optionsCA});
          }else if(e.value === "MX") {
            this.setState({ stateOptions : this.state.optionsMX});
          }
      }
    }
    
    handleCodeChange = (e) => {
        this.setState({ selectedCode : e.target.value});
    }
    onMobileNumberChange = (value, data, event, formattedValue) => {
       const phoneNumber = value;
       const dialCodeLength = data.dialCode.length;
      
       this.setState({
        dialCode: data.dialCode,
        selectedNumber: phoneNumber.slice((dialCodeLength)),
        mobileNo: value
      });
    }

    onMobileUpdate = (value, data, event, formattedValue) => {
       const phoneNumber = value;
       const dialCodeLength = data.dialCode.length;
      
       this.setState({
        dialCode: data.dialCode,
        selectedNumber: phoneNumber.slice((dialCodeLength)),
        telephoneNumber: value
      });
    }

    handleConsent = (value) => {
      this.setState({
        consent: value,
      });
    };

    handleKeyPress = (e) => {
      preventNonDigitCharacters(e);
    };

    onDobChange = (e, key) => {
      let value = e.target.value.trim();
      this.setState((prevState) => {
        const prevValue = prevState[key];
        if (prevValue.length < value.length) {
          if (value.length === 2 || value.length === 5) {
            value += "/";
          }
        }
        return {
          ...prevState,
          [key]: value,
        };
      });
    };

    changeSocialHandler = (e) => {
      const {
        target: { value },
      } = e;
      const formattedSSN = this.formatSSN(e.target.value);
      this.setState((prevState) => {
        return {
          ...prevState,
          socialNumber: formattedSSN,
        };
      });
    };

    formatSSN(value) {
      if (!value) return value;
      const ssn = value.replace(/[^\d]/g, "");
      if (ssn.length <=3) {
          return ssn;
      }
      else if (ssn.length < 6) {
        return `${ssn.slice(0, 3)}-${ssn.slice(3)}`;
      }
      return `${ssn.slice(0, 3)}-${ssn.slice(3, 5)}-${ssn.slice(5, 9)}`;
    };

    showError = (errorText) => {
      this.setState({
        errorText
      });
      window.scrollTo({
        behavior: "smooth",
        top: 0
      });
    };

    onFieldValueChange = (e, key) => {
      const {
        target: { value }
      } = e;
      if (value !== '') {
        this.setState({
          [key]: value
        });
      }
    };

    reloadPage = () => {
      window.location.reload();
    }

    handleTabChange = (key) => {
      this.setState({
        selectedTab: key,
        mobileNo: ''
      })
      if(key === "SMS") 
      {
        this.clearIdleTimer();
        this.state.smsPayload.callbacks[2].input[0].value = 1;
        let url = this.getEndPoint() + '?service=IDVerificationLevel2&authIndexType=service&authIndexValue=IDVerificationLevel2'; 
        fetch(url, {
          method: 'POST',
          mode: 'cors',
          headers: {
            "Accept": '*/*',
            "Accept-API-Version": "protocol=1.0,resource=2.1",
            "Content-Type" : "application/json"
          },
          body: JSON.stringify(this.state.smsPayload)
        }) 
         .then(response =>  {
            let responseStatus = response.status ? response.status : response.code;
            if (responseStatus !== 200) {
              let result_value = {
                  responseCode  : response.status ? response.status : response.code
              } 
              this.handleErrorResponse(result_value);
            }      
            const contentType = response.headers.get('content-type');
            if(responseStatus === 200) {
              if(contentType && contentType.includes('text/html')) {
                return response.text().then((body) => {
                  //error screen
                    this.setState({
                    htmlError: body
                    });
                  this.fetchDOMElement()
                });
              }
              else {
                return response.json().then((data) => {
                  this.setState({
                    smsResponsePayload: data
                  })
                }); 
              }
            }
            else {
              throw new Error("Unsupported content" + contentType)
            }
         });
      } 
      else if(key === "QR")
      {
        let inputData;
        if(this.state.resendSMS !== true) 
        {
          inputData = this.state.smsResendPayload
          inputData.callbacks[2].input[0].value = 2;         
        }
        else {
          inputData = this.state.smsResponsePayload;
          inputData.callbacks[3].input[0].value = 1;  
        }
        //resendSMSPayload
        let url = this.getEndPoint() + '?service=IDVerificationLevel2&authIndexType=service&authIndexValue=IDVerificationLevel2'; 
        fetch(url, {
          method: 'POST',
          mode: 'cors',
          headers: {
            "Accept": '*/*',
            "Accept-API-Version": "protocol=1.0,resource=2.1",
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(inputData)
        }) 
         .then(response =>  {
            let responseStatus = response.status ? response.status : response.code;
              if (responseStatus !== 200) {
                let result_value = {
                    responseCode  : response.status ? response.status : response.code
                } 
                this.handleErrorResponse(result_value);
              }
              const contentType = response.headers.get('content-type');
              if(responseStatus === 200) {
                if(contentType && contentType.includes('text/html')) {
                  return response.text().then((body) => {
                    //error screen
                      this.setState({
                        htmlError: body
                      });
                    this.fetchDOMElement()
                  });
                }
                else {
                  return response.json().then((data) => {
                    if(data.callbacks[0].output[0].value === 'GENERATE_LINK_RESULT')
                    {
                      let link;
                      let result = JSON.parse(data.callbacks[1].output[0].value);
                      if(this.state.paramState == 'success'){
                        link = result.linkGenerated + '&state=success'
                      }
                      else {
                        link = result.linkGenerated;
                      }
                      this.setState({
                        QRLink:link,
                        smsPayload: data,
                        smsSent: false,
                      }); 
                    }
                    else if(data.callbacks[0].output[0].value === "VERIFICATION_RESULT_ERROR") {
                      const result_value = data.callbacks[1].output[0].value; 
                      this.handleErrorResponse(result_value);
                  }
                    else {
                      this.setState({
                        rejectStatus: true,
                        screen:8,
                        rightScreen: 8,
                      }); 
                    }
                  });
                }
              }
              else {
                throw new Error("Unsupported content" + contentType)
              }
        });        
      }
    }

    verificationKBA = () => {
      let url = this.getEndPoint() + '?service=IDVerificationKBA&authIndexType=service&authIndexValue=IDVerificationKBA'; 
      fetch(url, {
        method: 'POST',
        mode: 'cors',
        headers: {
         "Accept": '*/*',
         "Accept-API-Version": "protocol=1.0,resource=2.1",    
        },
      }) 
       .then(response =>  {
          let responseStatus = response.status ? response.status : response.code;
          if (responseStatus !== 200) {
            let result_value = {
                responseCode  : response.status ? response.status : response.code
            } 
            this.handleErrorResponse(result_value);
          }       
          const contentType = response.headers.get('content-type');
          if(responseStatus === 200) {
            if(contentType && contentType.includes('text/html')) {
              return response.text().then((body) => {
                //error screen
                  this.setState({
                  htmlError: body
                  });
                this.fetchDOMElement()
              });
            }
            else {
              return response.json().then((data) => {
                if(data.callbacks[0].output[0].value === "KBA_INITIATE") {
                  this.setState({
                    qnaPayload : data
                  })
                }
                else if(data.callbacks[0].output[0].value === "VERIFICATION_RESULT_ERROR") {
                    const result_value = data.callbacks[1].output[0].value; 
                    this.handleErrorResponse(result_value);
                }
              });
            }
          }
            else {
              throw new Error("Unsupported content" + contentType)
            }
      });
    }

    hideLanguageOption = (type) => {  
      const logoutSection = document.querySelector(".right__section");  
      if(type === 'block') {
        logoutSection.style.display = "flex";
      }  
      else {        
        logoutSection.style.display = "none";
      }
    }

    moveNextPage = (e) => {
      if(this.state.screen === 3) {        
        this.hideLanguageOption();
        this.verificationKBA();
        this.setState({
          screen:this.state.screen + 1,
          rightScreen: this.state.rightScreen + 1,
        }); 
      }
      else {        
        this.setState({
          screen:this.state.screen + 1,
          rightScreen: this.state.rightScreen + 1,
        }); 
      }             
      window.scrollTo({
        behavior: "smooth",
        top: 0
      });
  }

  toFetchQna = (e) => {
      e.currentTarget.disabled = true;
      e.preventDefault();
      let dataObj = this.state.qnaPayload;      
      dataObj.callbacks[1].input[0].value = localStorage.getItem('lnTransactionId');
      this.hideLanguageOption();
      let url = this.getEndPoint() + '?service=IDVerificationKBA&authIndexType=service&authIndexValue=IDVerificationKBA'; 
      fetch(url, {
        method: 'POST',
        mode: 'cors',
        headers: {
          "Accept": '*/*',
          "Accept-API-Version": "protocol=1.0,resource=2.1",
          'Content-Type': 'application/json',        
        },
        body: JSON.stringify(dataObj)
      }) 
      .then(response =>  {
          this.hideLanguageOption('block');
         let responseStatus =  response.status ? response.status : response.code;
            if (responseStatus !== 200) {
              let result_value = {
                  responseCode  : response.status ? response.status : response.code
              } 
              this.handleErrorResponse(result_value);
            }
          const contentType = response.headers.get('content-type');
          if(responseStatus === 200) {
            if(contentType && contentType.includes('text/html')) {
              return response.text().then((body) => {
                //error screen
                  this.setState({
                  htmlError: body
                  });
                this.fetchDOMElement()
              });
            }
            else {
              return response.json().then((data) => {    
                if(data.callbacks[0].output[0].value === "FETCH_QNA")
                {
                  this.setState({
                    qnaPayload: data
                  })
                  this.moveToQna();
                }
                else if(data.callbacks[0].output[0].value === "VERIFICATION_RESULT_ERROR") {
                    const result_value = data.callbacks[1].output[0].value; 
                    this.handleErrorResponse(result_value);
                }
              });
            }
          }
          else {
            throw new Error("Unsupported content" + contentType)
          }
      });
  }

    moveToQna = () => {
      this.hideLanguageOption();
      let dataObj = this.state.qnaPayload;
      if(dataObj.callbacks[0].output[0].value === "FETCH_QNA")
      {
        dataObj.callbacks[1].input[0].value = localStorage.getItem('authSelectionId');
      }
      const loader = document.querySelector(".loader");
      if (loader) {
        loader.classList.remove("hide");
      }
      let url = this.getEndPoint() + '?service=IDVerificationKBA&authIndexType=service&authIndexValue=IDVerificationKBA'; 
      fetch(url, {
        method: 'POST',
        mode: 'cors',
        headers: {
          "Accept": '*/*',
          "Accept-API-Version": "protocol=1.0,resource=2.1",
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(dataObj)
      }) 
      .then(response =>  {
          this.hideLanguageOption('block');
          let responseStatus =  response.status ? response.status : response.code;
            if (responseStatus !== 200) {
              let result_value = {
                  responseCode  : response.status ? response.status : response.code
              } 
              this.handleErrorResponse(result_value);
            }
          const contentType = response.headers.get('content-type');
          if(responseStatus === 200) {
            if(contentType && contentType.includes('text/html')) {
              return response.text().then((body) => {
                //error screen
                  this.setState({
                  htmlError: body
                  });
                this.fetchDOMElement()
              });
            }
            else {
              return response.json().then((data) => {    
                if(data.callbacks[0].output[0].value === "FETCH_QNA_RESPONSE")
                {
                  this.setState({
                    qnaPayload: data
                  })
                  let result = JSON.parse(data.callbacks[1].output[0].value) 
                  if(result.QuestionSetId) {
                    this.hideLanguageOption();
                    this.setState({
                      questionId : result.QuestionSetId,
                      questionsArray : result.Questions,
                      screen:10,
                      rightScreen: 10,
                    }); 
                  }
                  else {
                    this.setState({
                      rejectStatus: true,
                      screen:8,
                      rightScreen: 8,
                    }); 
                  }
                }
                else if(data.callbacks[0].output[0].value === "VERIFICATION_RESULT_ERROR") {
                    const result_value = data.callbacks[1].output[0].value; 
                    this.handleErrorResponse(result_value);
                }
                loader.classList.add("hide");
              });
            }
          }
          else {
            throw new Error("Unsupported content" + contentType)
          }
      });
    }

    convertDOB(dob) {
      const [month, day, year] = dob.split('/');
      return `${month}-${day}-${year}`;
    }

    convertDOBPicker(dob, key) {
      const [year, month, day] = dob.split('-');
      if(key == 1) 
      {
        return `${month}/${day}/${year}`;
      }
      else {
        return `${month}-${day}-${year}`;
      }
    }

    submitQna = (e) => {
      e.preventDefault();
      let button = e.currentTarget;
      button.disabled = true;
      const logoutSection = document.querySelector(".right__section");
      let length = document.querySelectorAll("input[type='radio']:checked").length;
      if(length != this.selectedQuestions.length) {
        this.setState({
          radioError:  "common.errors.required"
        });
      }
      else {
        let inputData = this.state.qnaPayload;
        inputData.callbacks[2].input[0].value = localStorage.getItem('authSelectionId');
        inputData.callbacks[1].output[0].value = "QnA";
        if(inputData.callbacks[0].output[0].value === "FETCH_QNA_RESPONSE")
        {
          inputData.callbacks[3].input[0].value = "INITIAL";
        }
        else 
        {
          inputData.callbacks[3].input[0].value = "CHALLENGE";
        } 
        inputData.callbacks[4].input[0].value = JSON.stringify(this.state.questionId);
        inputData.callbacks[5].input[0].value = JSON.stringify(this.selectedQuestions, null, '\t');
        let url = this.getEndPoint() + '?service=IDVerificationKBA&authIndexType=service&authIndexValue=IDVerificationKBA'; 
        fetch(url, {
          method: 'POST',
          mode: 'cors',
          headers: {
            "Accept": '*/*',
            "Accept-API-Version": "protocol=1.0,resource=2.1",
            'Content-Type': 'application/json'         
          },
          body: JSON.stringify(inputData)
        }) 
        .then(response =>  {
          button.disabled = false;
          let responseStatus =  response.status ? response.status : response.code;
            if (responseStatus !== 200) {
              let result_value = {
                  responseCode  : response.status ? response.status : response.code
              } 
              this.handleErrorResponse(result_value);
            }
          const contentType = response.headers.get('content-type');
          if(responseStatus === 200) {
            if(contentType && contentType.includes('text/html')) {
              return response.text().then((body) => {
                //error screen
                  this.setState({
                  htmlError: body
                  });
                this.fetchDOMElement()
              });
            }
            else {
              return response.json().then((data) => {
                  this.selectedQuestions = [];
                  this.setState({
                    qnaPayload : data
                  })
                  if(data.callbacks[0].output[0].value === "LEVEL_2_RESULT") {
                    let result = data.callbacks[1].output[0].value
                    if(result.redirect === "true") {
                        this.handleErrorResponse(result)
                     }
                     else if(result.status === "COMPLETE" && result.verificationResult === "pass") {
                        logoutSection.style.display = "block";
                        this.setState({
                          questionId : data.QuestionSetId,
                          questionsArray : data.Questions,
                          screen:7,
                          rightScreen: 7,
                        }); 
                      }
                    else if(result.status === "ERROR"){
                        this.handleErrorResponse(result);
                    }
                    else {
                      logoutSection.style.display = "block";
                      this.setState({
                        rejectStatus: true,
                        screen:8,
                        rightScreen: 8,
                      });
                    }
                  }
                  else if(data.callbacks[0].output[0].value === "CHALLENGE_QNA_RESPONSE")
                  {
                    let result = JSON.parse(data.callbacks[1].output[0].value)
                    if(result.QuestionSetId) {
                      this.setState({
                        questionId : result.QuestionSetId,
                        questionsArray : result.Questions,
                        screen:10,
                        rightScreen: 10,
                      }); 
                    }
                    else {
                        logoutSection.style.display = "block";
                        this.setState({
                          rejectStatus: true,
                          screen:8,
                          rightScreen: 8,
                        }); 
                      } 
                  }
                  else if(data.callbacks[0].output[0].value === "VERIFICATION_RESULT_ERROR") {
                    const result_value = data.callbacks[1].output[0].value; 
                    this.handleErrorResponse(result_value);
                  }
                  else {
                    logoutSection.style.display = "block";
                    this.setState({
                      rejectStatus: true,
                      screen:8,
                      rightScreen: 8,
                    }); 
                  } 
             });
            }
          }
          else {
            throw new Error("Unsupported content" + contentType)
          }
        });
      }
    }

    onClose = () => {
     // hide descriptive content
     this.setState({
        showDescriptive: false
      }); 
    }

    onOptionsChange = (e) => {
      let index;
      if(this.selectedQuestions != '') 
        {
          index = this.selectedQuestions.findIndex((ele) => {
            if(ele.QuestionId == e.target.name) {
              return true;
            }
            else {
              return false;
            }
          })
      }
      if(index != undefined && index >= 0) 
      {
        this.selectedQuestions[index].Choices = [];
        this.selectedQuestions[index].Choices.push({
          "Choice" : e.target.value
        });
      }
      else {
        let data = {};
        data.Choices = [];
        data.Choices.push({
            "Choice" : e.target.value
        });
        this.selectedQuestions.push(data);  
        let qId = e.target.name;
        data.QuestionId = Number(qId);  
      }
    }
    onSuccessNavigation = (e) => {
      this.setState({
        screen:4,
        rightScreen:4,
      });                
      window.scrollTo({
        behavior: "smooth",
        top: 0
      });
    }
    onRegister = (e) => {
      this.setState({
        errorArray: [],
        errorText: "",
        formSubmitted:true
      });
      e.preventDefault();
      const {
        givenName,
        sn,
        mail,
        telephoneNumber,
        selectedNumber,
        dateOfBirth,
        socialNumber,
        address1,
        address2,
        city,
        states,
        country,
        zipCode,
        verificationPayload,
        disableCaptcha,
        googleCaptchaResponse,
        sessionId,
      } = this.state;
      const hasGivenName = this.isFormFieldValid(givenName, "givenNameError");
      const hasSn = this.isFormFieldValid(sn, "snError");
      const hasMail = this.isFormFieldValid(mail, "emailError");  
      const hasdateOfBirth = this.isFormFieldValid(dateOfBirth, "dateOfBirthError");
	    const hasSSN = this.isFormFieldValid(socialNumber, "ssnError");
      const hassAddressOne = this.isFormFieldValid(address1, "addressOneError");
      const hasCity = this.isFormFieldValid(city, "cityError");
      const hasState = this.isFormFieldValid(states, "stateError");
      const hasZip = this.isFormFieldValid(zipCode, "zipError");
      const hasCountry = this.isFormFieldValid(country, "countryError");
      const hasPhone = this.isFormFieldValid(selectedNumber, 'mobileNumberError');
      let hasAddressTwo
      if(address2 !== '') {
        hasAddressTwo = this.isFormFieldValid(address1, "addressTWoError");
      }
      else 
          hasAddressTwo = ''
      if (
        hasGivenName ||
        hasSn ||
        hasMail ||
		    hasdateOfBirth ||
		    hasSSN ||
        hassAddressOne ||
        hasCity ||
        hasCountry ||
        hasState ||
        hasZip ||
        hasPhone ||
        hasAddressTwo
      ) {
        this.showError("common.errors.required");
      } 
      else if (!disableCaptcha && !googleCaptchaResponse) {
        this.showError("common.errors.recaptchaError");
      }
      else {
        var dob;
        if(dateOfBirth.includes('-')) {
          dob = this.convertDOBPicker(dateOfBirth, 2);
        } 
        else {          
          dob = this.convertDOB(dateOfBirth);
        }  
        var formattedSSN = this.state.socialNumber.replace(/-/g, ''); 
        if(this.state.verificationPayload.callbacks[0].type === 'ReCaptchaCallback')    {
            verificationPayload.callbacks[0].input[0].value = googleCaptchaResponse;
            if(this.state.paramState === "success") {
              verificationPayload.callbacks[2].input[0].value = "CTDAS10182024v1";
            }
            else {
              verificationPayload.callbacks[2].input[0].value = sessionId;
            } 
            if(this.state.paramState == 'success') {
                verificationPayload.callbacks[3].input[0].value = "10.10.10.10";
            }
            else {
              verificationPayload.callbacks[3].input[0].value = this.state.ipAddress;
            }
            verificationPayload.callbacks[4].input[0].value = givenName;
            verificationPayload.callbacks[5].input[0].value = sn;
            verificationPayload.callbacks[6].input[0].value = mail;        
            verificationPayload.callbacks[7].input[0].value = "+" + telephoneNumber;
            verificationPayload.callbacks[8].input[0].value = dob;       
            verificationPayload.callbacks[9].input[0].value = formattedSSN;       
            verificationPayload.callbacks[10].input[0].value = address1;        
            verificationPayload.callbacks[11].input[0].value = address2;               
            verificationPayload.callbacks[12].input[0].value = zipCode;               
            verificationPayload.callbacks[13].input[0].value = city;               
            verificationPayload.callbacks[14].input[0].value = states.value;               
            verificationPayload.callbacks[15].input[0].value = country.value; 
            verificationPayload.callbacks[16].input[0].value = this.state.selectedOption;
        }
        else {
          if(this.state.paramState === "success") {
              verificationPayload.callbacks[1].input[0].value = "CTDAS10182024v1";
            }
            else {
              verificationPayload.callbacks[1].input[0].value = sessionId;
            } 
            if(this.state.paramState == 'success') {
                verificationPayload.callbacks[2].input[0].value = "10.10.10.10";
            }
            else {
              verificationPayload.callbacks[2].input[0].value = this.state.ipAddress;
            }
            verificationPayload.callbacks[3].input[0].value = givenName;
            verificationPayload.callbacks[4].input[0].value = sn;
            verificationPayload.callbacks[5].input[0].value = mail;        
            verificationPayload.callbacks[6].input[0].value = "+" + telephoneNumber;
            verificationPayload.callbacks[7].input[0].value = dob;       
            verificationPayload.callbacks[8].input[0].value = formattedSSN;       
            verificationPayload.callbacks[9].input[0].value = address1;        
            verificationPayload.callbacks[10].input[0].value = address2;               
            verificationPayload.callbacks[11].input[0].value = zipCode;               
            verificationPayload.callbacks[12].input[0].value = city;               
            verificationPayload.callbacks[13].input[0].value = states.value;               
            verificationPayload.callbacks[14].input[0].value = country.value; 
            verificationPayload.callbacks[15].input[0].value = this.state.selectedOption;
        }
        this.setState({
            regButton: true
        });
        let url = this.getEndPoint() + '?service=IDVerificationLevel1&authIndexType=service&authIndexValue=IDVerificationLevel1'; 
        fetch(url, {
          method: 'POST',
          mode: 'cors',
          headers: {
            "Accept": '*/*',
            "Accept-API-Version": "protocol=1.0,resource=2.1",
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(this.state.verificationPayload)
        }) 
        .then(response =>  {
            this.setState({
                regButton: false
            });
            let responseStatus =  response.status ? response.status : response.code;
            if (responseStatus !== 200) {
              let result_value = {
                  responseCode  : response.status ? response.status : response.code
              } 
              this.handleErrorResponse(result_value);
            }
            const contentType = response.headers.get('content-type');
            if(responseStatus === 200) {
              if(contentType && contentType.includes('text/html')) {
                return response.text().then((body) => {
                  //error screen
                    this.setState({
                    htmlError: body
                    });
                  this.fetchDOMElement()
                });
              }
              else {
                return response.json().then((data) => {
                  this.setState({
                      regButton: false
                  });
                  this.genericResponse(data);
                  this.googleCaptchaReset();
                });
              }
            }
            else {
              throw new Error("Unsupported content" + contentType)
            }
        });
      }
    };

    genericResponse = (res) => {
        if (res.callbacks && res.callbacks[0].output[0].value === "LEVEL_1_RESULT") {          
            let result = res.callbacks[1].output[0].value;
            if(result.status === "COMPLETE") {              
              this.handleErrorResponse(result);
            }
            else if(result.status === "CHALLENGE")
            {
              result.authSelectionMethods.forEach(element => {
                if(this.state.selectedOption == "en_US") 
                {
                    if(element.reasonCode == "English Questions")
                    {                    
                        localStorage.setItem("authSelectionId", element.authSelectionId);
                    }
                }
                else {
                  if(element.reasonCode == "Spanish Questions")
                    {                    
                        localStorage.setItem("authSelectionId", element.authSelectionId);
                    }
                }
              });
              localStorage.setItem("lnTransactionId", result.lnTransactionId);
              this.setState({
                screen:3,
                rightScreen: 3,
              });       
              this.hideLanguageOption();     
            }
            else {
              this.setState({
                screen:8,
                rightScreen:8,
                rejectStatus : true
              });   
            }
        }
        else if(res.callbacks[0].output[0].value === "VERIFICATION_RESULT_ERROR") {
            const result_value = res.callbacks[1].output[0].value; 
            this.handleErrorResponse(result_value);
        }
        else {
          this.setState({
            screen:8,
            rightScreen:8,
            rejectStatus : true
          });   
        }
    }

    googleCaptchaReset = () => {
      const { disableCaptcha } = this.state;
      if (!disableCaptcha) {
        this.setState({
          captchaReset: true,
          googleCaptchaResponse: ""
        });
        setTimeout(() => {
          this.setState({
            captchaReset: false
          });
        }, 100);
      }
    };

    generateQRCode = (e) => {
      let deviceType = this.detectDeviceType();
      if(deviceType === 'Desktop') {
      let button = e.currentTarget
      button.disabled = true;
      let inputData = this.state.linkPayload
      inputData.callbacks[1].input[0].value = localStorage.getItem("lnTransactionId");
      inputData.callbacks[2].input[0].value = this.state.selectedOption;
      let url = this.getEndPoint() + '?service=IDVerificationLevel2&authIndexType=service&authIndexValue=IDVerificationLevel2'; 
      fetch(url, {
        method: 'POST',
        mode: 'cors',
        headers: {
          "Accept": '*/*',
          "Accept-API-Version": "protocol=1.0,resource=2.1",
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(inputData)
      }) 
      .then(response =>  {
          button.disabled = false;
         let responseStatus =  response.status ? response.status : response.code;
            if (responseStatus !== 200) {
              let result_value = {
                  responseCode  : response.status ? response.status : response.code
              } 
              this.handleErrorResponse(result_value);
            }
          const contentType = response.headers.get('content-type');
          if(responseStatus === 200) {
            if(contentType && contentType.includes('text/html')) {
              return response.text().then((body) => {
                //error screen
                  this.setState({
                  htmlError: body
                  });
                this.fetchDOMElement()
              });
            }
            else {
              return response.json().then((data) => {
                this.setState({
                  smsPayload: data
                })
                if(data.callbacks[0].output[0].value === 'GENERATE_LINK_RESULT')
                {
                  let link;
                  let result = JSON.parse(data.callbacks[1].output[0].value);
                  if(this.state.paramState == 'success'){
                    link = result.linkGenerated + '&state=success'
                  }
                  else {
                    link = result.linkGenerated;
                  }
                  
                  this.setState({
                    QRLink:link
                  }); 
                  this.moveNextPage();
                }
                else if(data.callbacks[0].output[0].value === "VERIFICATION_RESULT_ERROR") {
                    const result_value = data.callbacks[1].output[0].value; 
                    this.handleErrorResponse(result_value);
                }
                else {
                  this.setState({
                    rejectStatus: true,
                    screen:8,
                    rightScreen: 8,
                  }); 
                }
              })
            }
          }
          else {
            throw new Error("Unsupported content" + contentType)
          }
        });
      }
      else {
        // mobile flow starts here
        const { selectedOption, paramState } = this.state;
        let URL;
        if(paramState === 'success') {
            URL =  '/ctidentity/level2Verification?transaction_id=' + localStorage.getItem("lnTransactionId") + '&lang=' + selectedOption + '&state=' + 'success';
        }
        else {
          URL =  '/ctidentity/level2Verification?transaction_id=' + localStorage.getItem("lnTransactionId") + '&lang=' + selectedOption;
        }
        let mobileUrl = this.getEndPoint() + '?service=IDVerificationTrueID&authIndexType=service&authIndexValue=IDVerificationTrueID';
        fetch(mobileUrl, {
          method: 'POST',
          mode: 'cors',
          headers: {
            "Accept": '*/*',
            "Accept-API-Version": "protocol=1.0,resource=2.1",
            "Content-Type" : "application/json"
          }
        }) 
       .then(response =>  {
         let responseStatus =  response.status ? response.status : response.code;
            if (responseStatus !== 200) {
              let result_value = {
                  responseCode  : response.status ? response.status : response.code
              } 
              this.handleErrorResponse(result_value);
            }
          const contentType = response.headers.get('content-type');
          if(responseStatus === 200) {
            if(contentType && contentType.includes('text/html')) {
              return response.text().then((body) => {
                //error screen
                  this.setState({
                  htmlError: body
                  });
                this.fetchDOMElement()
              });
            }
            else {
              return response.json().then((data) => {
                if (data && data.callbacks[0].output[0].value === "TRUEID_INITIATE") {
                  this.setState({
                    trueIDPayload: data
                  });
                  this.props.history.push(URL, {
                      deviceSource: deviceType,
                      payload: this.state.trueIDPayload,
                      refId: this.state.refID,
                      goto: this.state.goto
                  });
                }
                else if(data.callbacks[0].output[0].value === "VERIFICATION_RESULT_ERROR") {
                    const result_value = data.callbacks[1].output[0].value; 
                    this.handleErrorResponse(result_value);
                }
                else {
                  this.setState({
                    rejectStatus: true,
                    screen:8,
                    rightScreen: 8,
                  }); 
                }
              }); 
            }
          }
          else {
            throw new Error("Unsupported content" + contentType)
          }
        });
      }
    }
    detectDeviceType = () => {
    var device;
    let userAgent = navigator.userAgent || navigator.vendor || window.opera;
    if (/windows phone/i.test(userAgent)) {
        device = "Windows Phone";
    }
    else if (/android/i.test(userAgent)) {
        device = "Android";
    }

    else if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
        device = "iOS";
    }
    else if (/webOS|BlackBerry|IEMobile|Opera Mini/i.test(userAgent)) {
      device = "other Mobile"
    }
    else {
      device = 'Desktop'
    }
    return device;
  }
    generateSMS = (e) => {
        e.preventDefault();
        this.setState({
          telephoneNumberError: ""
        })
        let phoneValid = this.isFormFieldValid(this.state.selectedNumber, "mobileNumberError");

        if(phoneValid == '') {
          let formattedNo = "+" + this.state.mobileNo;
          this.state.smsResponsePayload.callbacks[1].input[0].value = this.state.QRLink;
          this.state.smsResponsePayload.callbacks[2].input[0].value = formattedNo;
          this.setState({
            disableSMSButton: true
          })
          if(this.state.smsSent) 
          {
            this.state.smsResendPayload.callbacks[2].input[0].value = 1;
            let url = this.getEndPoint() + '?service=IDVerificationLevel2&authIndexType=service&authIndexValue=IDVerificationLevel2'; 
            fetch(url, {
              method: 'POST',
              mode: 'cors',
              headers: {
                "Accept": '*/*',
                "Accept-API-Version": "protocol=1.0,resource=2.1",
                "Content-Type" : "application/json"
              },
              body: JSON.stringify(this.state.smsResendPayload)
            }) 
            .then(response =>  {
                let responseStatus =  response.status ? response.status : response.code;
                if (responseStatus !== 200) {
                  let result_value = {
                      responseCode  : response.status ? response.status : response.code
                  } 
                  this.handleErrorResponse(result_value);
                }
                const contentType = response.headers.get('content-type');
                if(responseStatus === 200) {
                  if(contentType && contentType.includes('text/html')) {
                    return response.text().then((body) => {
                      //error screen
                        this.setState({
                        htmlError: body
                        });
                      this.fetchDOMElement()
                    });
                  }
                  else {
                    return response.json().then((data) => {
                        this.setState({
                          smsResponsePayload: data,
                        })
                        if(data.callbacks[0].output[0].value === "VERIFICATION_RESULT_ERROR") {
                            const result_value = data.callbacks[1].output[0].value; 
                            this.handleErrorResponse(result_value);
                        }
                        else {
                          
                        this.state.smsResponsePayload.callbacks[1].input[0].value = this.state.QRLink;
                        this.state.smsResponsePayload.callbacks[2].input[0].value = "+" + this.state.mobileNo;
                        let url = this.getEndPoint() + '?service=IDVerificationLevel2&authIndexType=service&authIndexValue=IDVerificationLevel2'; 
                        fetch(url, {
                          method: 'POST',
                          mode: 'cors',
                          headers: {
                            "Accept": '*/*',
                            "Accept-API-Version": "protocol=1.0,resource=2.1",
                            "Content-Type" : "application/json"
                          },
                          body: JSON.stringify(this.state.smsResponsePayload)
                        }) 
                        .then(response =>  {
                          let responseStatus =  response.status ? response.status : response.code;
                            if (responseStatus !== 200) {
                              let result_value = {
                                  responseCode  : response.status ? response.status : response.code
                              } 
                              this.handleErrorResponse(result_value);
                            }
                            const contentType = response.headers.get('content-type');
                            if(responseStatus === 200) {
                              if(contentType && contentType.includes('text/html')) {
                                return response.text().then((body) => {
                                  //error screen
                                    this.setState({
                                      htmlError: body,
                                    });
                                  this.fetchDOMElement()
                                });
                              }
                              else {
                                return response.json().then((data) => {
                                  this.setState({
                                    smsResendPayload: data
                                  })
                                  if(data.callbacks[0].output[0].value === "SMS_SENT_SUCCESSFUL") {
                                    let result = JSON.parse(data.callbacks[1].output[0].value)
                                    if(result.linkSendStatus === "LINK_SENT_SUCCESS")
                                    {
                                        this.setState({
                                          smsSent : true,
                                          resendSMS: false,                                        
                                          disableSMSButton: false
                                        })
                                    }
                                  }
                                  else if (data.callbacks[0].output[0].value === 'SEND_SMS' && data.callbacks[4].output[0].value === 'INVALID_NUMBER') {
                                    this.setState({
                                        telephoneNumberError: "pages.idVerification.mobileInvalid",                    
                                        smsSent : false,
                                        smsResponsePayload: data,
                                        resendSMS: false,                                       
                                        disableSMSButton: false
                                      })
                                  }
                                  else if(data.callbacks[0].output[0].value === "VERIFICATION_RESULT_ERROR") {
                                      const result_value = data.callbacks[1].output[0].value; 
                                      this.handleErrorResponse(result_value);
                                  }
                                }); 
                              }
                            }
                            else {
                              throw new Error("Unsupported content" + contentType)
                            }
                        });  
                        }    
                    });
                  }
                }
                else {
                  throw new Error("Unsupported content" + contentType)
                }
            }); 
            //1st set ends here
          }
          else {  
            let url = this.getEndPoint() + '?service=IDVerificationLevel2&authIndexType=service&authIndexValue=IDVerificationLevel2';         
            fetch(url, {
              method: 'POST',
              mode: 'cors',
              headers: {
                "Accept": '*/*',
                "Accept-API-Version": "protocol=1.0,resource=2.1",
                "Content-Type" : "application/json"
              },
              body: JSON.stringify(this.state.smsResponsePayload)
            }) 
            .then((response) =>  {
               let responseStatus =  response.status ? response.status : response.code;
                if (responseStatus !== 200) {
                  let result_value = {
                      responseCode  : response.status ? response.status : response.code
                  } 
                  this.handleErrorResponse(result_value);
                }
                const contentType = response.headers.get('content-type');
                if(responseStatus === 200) {
                  if(contentType && contentType.includes('text/html')) {
                    return response.text().then((body) => {
                      //error screen
                        this.setState({
                          htmlError: body,
                        });
                      this.fetchDOMElement()
                    });
                  }
                  else {	
                    return response.json().then((data) => {
                      this.setState({
                        smsResendPayload: data
                      })
                      if(data.callbacks[0].output[0].value === "SMS_SENT_SUCCESSFUL") {
                        let result = JSON.parse(data.callbacks[1].output[0].value)
                        if(result.linkSendStatus === "LINK_SENT_SUCCESS")
                        {
                            this.setState({
                              smsSent : true,
                              resendSMS: false,                                        
                              disableSMSButton: false
                            })
                        }
                      }
                      else if (data.callbacks[0].output[0].value === 'SEND_SMS' && data.callbacks[4].output[0].value === 'INVALID_NUMBER') {
                        this.setState({
                            telephoneNumberError: "pages.idVerification.mobileInvalid",                    
                            smsSent : false,
                            smsResponsePayload: data,
                            resendSMS: false,                                       
                            disableSMSButton: false
                          })
                      }
                      else if(data.callbacks[0].output[0].value === "VERIFICATION_RESULT_ERROR") {
                          const result_value = data.callbacks[1].output[0].value; 
                          this.handleErrorResponse(result_value);
                      }
                  });
                  } 
                }//2nd set ends here
          });
        }
        }
    }

    pollingAPI = (e) => {
      //timer on continue
      this.clearIdleTimer();
      let button = e.currentTarget;
      button.disabled = true;
      let payloadData 
      if(e.currentTarget.closest('.tab-pane')?.id.includes('QR')) {
        payloadData = this.state.smsPayload
      }
      else {
        payloadData = this.state.smsResendPayload
      }
      let url = this.getEndPoint() + '?service=IDVerificationLevel2&authIndexType=service&authIndexValue=IDVerificationLevel2';   
      fetch(url, {
        method: 'POST',
        mode: 'cors',
        headers: {       
          "Accept": '*/*',
          "Accept-API-Version": "protocol=1.0,resource=2.1",
          "Content-Type" : "application/json"
        },
        body: JSON.stringify(payloadData)
      }) 
      .then((response) =>  {
          button.disabled = false;      
          let responseStatus =  response.status ? response.status : response.code;
            if (responseStatus !== 200) {
              let result_value = {
                  responseCode  : response.status ? response.status : response.code
              } 
              this.handleErrorResponse(result_value);
              clearInterval(this.timer);
            }
          const contentType = response.headers.get('content-type');
          if(responseStatus === 200) {
            if(contentType && contentType.includes('text/html')) {
              return response.text().then((body) => {
                //error screen
                  this.setState({
                  htmlError: body
                  });
                this.fetchDOMElement()
              });
            }
            else {
              return response.json().then((data) => {
                this.setState({
                  pollingPayload: data
                })
              });
            }
          }
          else {
            throw new Error("Unsupported content" + contentType)
          }
      });
      this.timer = setInterval(()=> this.getDocumentDetails(), 10000);
      this.moveNextPage(e);
    }
    getDocumentDetails = () => {
      let pollingData = this.state.pollingPayload;
      if(pollingData.callbacks[0].output[0].value === "POLLING_API")
      {
        pollingData.callbacks[1].input[0].value = localStorage.getItem("lnTransactionId");
      }
      let url = this.getEndPoint() + '?service=IDVerificationLevel2&authIndexType=service&authIndexValue=IDVerificationLevel2'; 
     fetch(url, {
        method: 'POST',
        mode: 'cors',
        headers: {
          "Accept": '*/*',
          "Accept-API-Version": "protocol=1.0,resource=2.1",
          "Content-Type" : "application/json"
        },        
        body: JSON.stringify(pollingData)
      }) 
      .then((response) =>  {
         let responseStatus =  response.status ? response.status : response.code;
            if (responseStatus !== 200) {
              let result_value = {
                  responseCode  : response.status ? response.status : response.code
              } 
              clearInterval(this.timer);
              this.handleErrorResponse(result_value);
            }       
          const contentType = response.headers.get('content-type');
          if(responseStatus === 200) {
            if(contentType && contentType.includes('text/html')) {
              return response.text().then((body) => {
                //error screen
                  this.setState({
                  htmlError: body
                  });
                this.fetchDOMElement()
              });
            }
            else {
              return response.json().then((data) => {
                this.setState({
                  pollingPayload: data
                },() =>{
                  console.log(this.state.pollingPayload)
                });        
                if(data.callbacks[0].output[0].value === "POLLING_RESULT") 
                {
                  let result = JSON.parse(data.callbacks[1].output[0].value);
                  if(result.status == "No Entries Found") {
                    //error screen
                    this.setState({
                      screen: 11
                    });
                    clearInterval(this.timer);
                  }
                  else if(result.status == "LINK_GENERATED") {
                    this.setState({
                      documentStep: 3
                    });
                  }
                  else if(result.status == "TnC_UPDATED") {
                    this.setState({
                      documentStep: 3
                    });
                  }
                  else if(result.status == "PROCESSING") {
                    this.setState({
                      documentStep: 4
                    });
                  }
                  else if(result.status == "COMPLETE") {
                    clearInterval(this.timer);
                    this.timer = null;
                   this.finalAPISubmission();
                  }
                  else if(result.status == "ERROR") {
                    this.setState({
                      screen: 11
                    });
                    clearInterval(this.timer);  
                  }
                  else if(result.status == "IAL1_FAILED") {
                    this.setState({
                      documentStep: 5
                    });
                  }
                  else {
                    clearInterval(this.timer);
                    this.timer = null;
                    this.setState({
                      rejectStatus: true,
                      screen:8,
                      rightScreen: 8,
                    }); 
                  }
                }
                else if(data.callbacks[0].output[0].value === "VERIFICATION_RESULT_ERROR") {
                    const result_value = data.callbacks[1].output[0].value; 
                    this.handleErrorResponse(result_value);
                }
              }) 
            }
          }     
          else {
            throw new Error("Unsupported content" + contentType)
          }
      });
    }
    onCaptchaChange = (value) => {
      this.setState({
        googleCaptchaResponse: value
      });
    };
    finalAPISubmission = () => {
        let inputData = this.state.pollingPayload;
        if(inputData.callbacks[0].output[0].value === "FETCH_L2_RESULT")
        {
          inputData.callbacks[1].input[0].value = localStorage.getItem("lnTransactionId");
        }
        let url = this.getEndPoint() + '?service=IDVerificationLevel2&authIndexType=service&authIndexValue=IDVerificationLevel2'; 
      fetch(url, {
        method: 'POST',
        mode: 'cors',
        headers: {
          "Accept": '*/*',
          "Accept-API-Version": "protocol=1.0,resource=2.1",
          "Content-Type" : "application/json"
        },        
        body: JSON.stringify(inputData)
      }) 
       .then(response =>  {
            let responseStatus =  response.status ? response.status : response.code;
            if (responseStatus !== 200) {
              let result_value = {
                  responseCode  : response.status ? response.status : response.code
              } 
              clearInterval(this.timer);
              this.handleErrorResponse(result_value);
            }     
          const contentType = response.headers.get('content-type');
          if(responseStatus === 200) {
            if(contentType && contentType.includes('text/html')) {
              return response.text().then((body) => {
                //error screen
                  this.setState({
                  htmlError: body
                  });
                this.fetchDOMElement()
              });
            }
            else {
              return response.json().then((data) => {
                if(data.callbacks[0].output[0].value == "FETCH_L2_RESULT")
                {
                    this.setState({
                      pollingPayload : data
                    });
                    this.finalAPISubmission();
                }
                else if(data.callbacks[0].output[0].value === "LEVEL_2_RESULT")
                {
                  let result = data.callbacks[1].output[0].value;
                  if(result.redirect === "true") {
                    this.handleErrorResponse(result);
                  }
                  else if(result.verificationLevel == 'IAL2' && result.status == 'COMPLETE') {
                    //success screen
                      this.setState({
                        screen:this.state.screen + 1,
                        rightScreen: this.state.rightScreen + 1,
                      }); 
                  }  
                  else if(result.status === "ERROR"){
                      this.handleErrorResponse(result);
                  }             
                  else {
                    this.setState({
                      screen:this.state.screen + 2,
                      rightScreen: this.state.rightScreen + 2,
                    }); 
                  }
                }  
                else if(data.callbacks[0].output[0].value === "VERIFICATION_RESULT_ERROR") {
                    const result_value = data.callbacks[1].output[0].value; 
                    this.handleErrorResponse(result_value);
                }                  
                window.scrollTo({
                  behavior: "smooth",
                  top: 0
                });
              })
            }
          }
          else {
            throw new Error("Unsupported content" + contentType)
          }
      });
    }
    render() {
        const { t } = this.props;
        const selectStyle = {
          control: base => ({
            ...base,
            height: '3.125rem',
            minHeight: '3.125rem',
            border: '0.0625rem solid rgba(153, 153, 153, 0.6)',
            boxShadow: '0 0.25rem 0.25rem 0 rgba(0, 0, 0, 0.25)',
            borderRadius: '0.3125rem' 
          })
        }
        const {
        givenName,
        sn,
        socialNumber,
        mail,
        errorText,
        givenNameError,
        snError,
        ssnError,
        emailError,
        address1,
        city,
        country,
        states,
        zipCode,
        address2,
        dateOfBirth,
        consent,
        dateOfBirthError,
        errorArray,
        screen,
        rightScreen,
        availableLanguages,
        selectedOption,
        carouselImages,
        imageIndex,
        tickImage,
        telephoneNumber,
        mobileNo,
        telephoneNumberError,
        radioError,
        addressOneError,
        addressTwoError,
        cityError,
        countryError,
        stateError,
        zipError,
        numberFocus,
        seeMore,
        QRLink,
        cityOptions,
        rejectStatus,
        questionsArray,
        smsSent,
        disableCaptcha,
        captchaReset,
        googleCaptchaToken,
        showPassword,
        showPopup,
        showCancelPopup,
        stateOptions,
        showDescriptive,
        regButton,
        todayDate,
		    htmlError,
        disableSMSButton,
        startTransaction,
        loading,
        isSystemError,
        showScreen
     } = this.state;
       const langOptions = availableLanguages.map(lang => ({
          value: lang,
          label: t(`pages.changePreferredLang.languages.${lang}`)
      }));
    const defaultOption = langOptions.find(option => option.value === selectedOption)
     let documentContent;
     if(this.state.documentStep === 1) {
        documentContent = <p className="context" role="alert" aria-live="polite" style={{textAlign:`center`, marginTop: `0`, fontStyle: `normal`, fontSize: `16px`}}>{t("pages.idVerification.partFour.contentTwo")}</p>
     }
     else if (this.state.documentStep === 2) {
        documentContent = <p className="context" role="alert" aria-live="polite" style={{textAlign:`center`, marginTop: `0`, fontStyle: `normal`, fontSize: `16px`}}>{t("pages.idVerification.docStepThree")}</p>
     }
     else if (this.state.documentStep === 3) {
        documentContent = <p className="context" role="alert" aria-live="polite" style={{textAlign:`center`, marginTop: `0`, fontStyle: `normal`, fontSize: `16px`}}>{t("pages.idVerification.docStepOne")}</p>
     }
     else if(this.state.documentStep === 4) {
        documentContent = <p className="context" role="alert" aria-live="polite" style={{textAlign:`center`, marginTop: `0`, fontStyle: `normal`, fontSize: `16px`}}>{t("pages.idVerification.docStepTwo")}</p>
     }
     else if(this.state.documentStep === 5) {
        documentContent = <p className="context" role="alert" aria-live="polite" style={{textAlign:`center`, marginTop: `0`, fontStyle: `normal`, fontSize: `16px`}}>{t("pages.idVerification.docStepFour")}</p>
     }

      if(loading) {
         return <img className="initial-loading" src={Loading} alt=""/>   
      }
      return (
        <>
                   
             {isSystemError && (
                   <SystemDownTime />
                 )}
             {!isSystemError && showScreen && (              
                  <div className={`${(errorText || errorArray.length > 0) && "has-error"}`} style={{flexGrow:1}}>
                    <div className={screen === 1 
                      ? "wrapper register one verification" : "wrapper register verification"} 
                      style={{ backgroundImage: `url(${carouselImages[imageIndex].image})` }}>
                    {(errorText) && (
                      <WithError errors={errorText} errorArray={errorArray} />
                    )}   
                    {((screen > 1 && screen < 7) || (screen === 10)) && (

                      showDescriptive ?
                      <>
                      
                      <div className="descriptive-content" ref={this.DescriptionPopup}>
                        <p>{t("pages.idVerification.descriptiveContent")}</p>
                        <Button
                            className="popup__wrapper-body-header-close"
                            onClick={() => {
                              this.onClose()
                            }}
                            variant="light"
                            aria-label="Close"
                          >
                            {t("pages.idVerification.dismiss")}
                          </Button>
                      </div>
                      </>
                      : <></> 
                    )}
                    
                    <Container
              className={`container wrapper__container ${
                (errorText || errorArray.length > 0) && "haserror"
              }`}
            >
              <Row>
                <>
                  {screen === 2 && (
                    
                      <Col lg={{ span: 6 }} className="form-container">
                        <div className="wrapper__container-card">
                          <div className="wrapper__container-card-body">
                            <h1 className="wrapper__container-card-body-title">
                            {t("pages.idVerification.sampleTransaction")}
                            </h1>
                            {/* <p>{t("pages.idVerification.formContentOne")}</p> */}
                            <p style={{marginTop:`20px`, marginBottom:`10px`}}>{t("pages.idVerification.formContentTwo")}</p>
                            <Form>
                              <Form.Row>
                                <Col className="pr-2" lg={{ span: 6 }}>
                                  <Form.Group controlId="firstName">
                                    <Form.Label>
                                      {t("pages.registration.firstName")}
                                    </Form.Label>
                                    <Form.Control
                                      autoFocus
                                      value={givenName}
                                      disabled={this.state.isNameDisabled}
                                      maxLength="40"
                                      onBlur={(e) => {
                                        this.isFormFieldValid(e, "givenNameError");
                                      }}
                                      onChange={(e) => {
                                        this.onFirstAndLastNameChange(
                                          e,
                                          "givenName"
                                        );
                                      }}
                                      className={
                                        givenNameError ? "error-input" : undefined
                                      }
                                      aria-required
                                      aria-invalid={!!givenNameError}
                                      aria-describedby="firstname-error"
                                    />
                                    <p className="error-text" id="firstname-error">
                                      {givenNameError && t(givenNameError)}
                                    </p>
                                  </Form.Group>
                                </Col>
                                <Col className="pl-2" lg={{ span: 6 }}>
                                  <Form.Group controlId="lastName">
                                    <Form.Label>
                                      {t("pages.registration.lastName")}
                                    </Form.Label>
                                    <Form.Control
                                      value={sn}
                                      maxLength="80"
                                      disabled={this.state.isNameDisabled}
                                      onBlur={(e) => {
                                        this.isFormFieldValid(e, "snError");
                                      }}
                                        onChange={(e) => {
                                        this.onFirstAndLastNameChange(
                                          e,
                                          "sn"
                                        );
  }}
                                      className={
                                        snError ? "error-input" : undefined
                                      }
                                      aria-required
                                      aria-invalid={!!snError}
                                      aria-describedby="lastname-error"
                                    />
                                    <p className="error-text" id="lastname-error">
                                      {snError && t(snError)}
                                    </p>
                                  </Form.Group>
                                </Col>
                              </Form.Row>     
                              <Form.Row>
                                <Col className="pl-2" lg={{ span: 6 }}>
                                                        
                              <Form.Group controlId="email">
                                <Form.Label id="idv-email-label">
                                  {t("pages.registration.email")}
                                </Form.Label>
                                <Form.Control
                                  type="email"
                                  value={mail}
                                  onChange={(e) => {
                                    const value = e.target.value
                                      .trim()
                                      .toLowerCase();
                                    this.setState(
                                      {
                                        mail: value
                                      },
                                      () => {
                                        this.isFormFieldValid(
                                          value,
                                          "emailError"
                                        );
                                      }
                                    );
                                  }}
                                  onBlur={(e) => {
                                    this.isFormFieldValid(e, "emailError");
                                  }}
                                  className={emailError ? "error-input" : undefined}
                                  aria-invalid={!!emailError}
                                  aria-required
                                  aria-labelledby="idv-email-label emailInfo"
                                  aria-describedby="email-error"
                                />
                                <p className="context" id="emailInfo">
                                {t("pages.registration.emailContext")}
                                </p>
                                <p className="error-text" id="email-error">
                                  {emailError && t(emailError)}
                                </p>
                              </Form.Group>
                                </Col>
                                <Col className="pl-2" lg={{ span: 6 }}>
                                <Form.Group>
                                    <Form.Label id="idv-phone-label">
                                      {t("pages.login.phoneNumber")}
                                    </Form.Label>
                                    <PhoneInput
                                        country={'us'}
                                        onlyCountries={['us']}
                                        disableDropdown={true}
                                        value={telephoneNumber}
                                        className={
                                          telephoneNumberError ? "error-input" : undefined
                                        }
                                        onChange={this.onMobileUpdate}
                                        countryCodeEditable={false}
                                        onFocus={() => {
                                            this.setState({
                                              numberFocus: true
                                            });
                                          }}
                                        onBlur={(e) => {
                                            this.isFormFieldValid(e, "phoneError");
                                          }}
                                        inputProps={{
                                            name: 'phone',
                                            required: true,
                                            autoComplete: 'tel',
                                            'aria-labelledby': 'idv-phone-label telephoneInfo',
                                            'aria-describedby': 'telephoneInfo telephone-number-error',
                                            'aria-invalid': !!telephoneNumberError,
                                          }}
                                    />
                                    <p className="context" id="telephoneInfo">
                                    {t("pages.registration.mobileUSUpdated")}
                                    </p>
                                    <p className="error-text" id="telephone-number-error">
                                      {telephoneNumberError && t(telephoneNumberError)}
                                    </p>
                                </Form.Group>
                                </Col>
                              </Form.Row> 
                              <Form.Row>
                                <Col className="pl-2" lg={{ span: 6 }}>
                                <Form.Group controlId="dateOfBirth">
                                  <Form.Label>
                                    {t("pages.identity.verifyWithDL.dateOfBirth")}
                                  </Form.Label>
                                  <Form.Control
                                    value={dateOfBirth}
                                    onKeyDown={this.handleKeyPress}
                                    placeholder={t(
                                      "pages.identity.verifyWithDL.dobPlaceholder"
                                    )}
                                    type="date"
                                    min={"1000-01-01"}
                                    max={todayDate}
                                    pattern="[0-9]{2}/[0-9]{2}/[0-9]{4}"
                                    className={dateOfBirthError ? "error-input" : undefined}
                                    onChange={(e) => {
                                      this.onDobChange(e, "dateOfBirth");
                                    }}                    
                                    onBlur={(e) => {
                                      this.isFormFieldValid(e, "dateOfBirthError");
                                    }}
                                    aria-invalid={!!dateOfBirthError}
                                    aria-required
                                    aria-describedby="date-of-birth-error"
                                  />
                                  <p className="error-text" id="date-of-birth-error">
                                    {dateOfBirthError && t(dateOfBirthError)}
                                  </p>
                                </Form.Group>                                    </Col>
                                <Col className="pl-2" lg={{ span: 6 }}>
                                <Form.Group controlId="ssn">
                              <Form.Label>
                                {t("pages.identity.ssn")}
                              </Form.Label>
                              <Form.Control
                                maxLength={11}
                                value={socialNumber}
                                type={showPassword ? "text" : "password"}
                                aria-invalid={!!ssnError}
                                aria-describedby="ssn-error"
                                onChange={(e) => this.changeSocialHandler(e)}
                                onBlur={(e) => {
                                      this.isFormFieldValid(e, "ssnError");
                                    }}
                                className={
                                  ssnError
                                    ? "error-field ssn-input"
                                    : "ssn-input"
                                }
                              />
                                <span 
                                className={
                                  showPassword ? "eye-icon show" : "eye-icon"
                                }
                                role="button"
                                tabIndex="0"
                                aria-label={
                                  showPassword
                                    ? t("pages.login.hidePassword")
                                    : t("pages.login.showPassword")
                                }
                                onClick={() => this.showPassword()}
                                onKeyDown={(e) => this.HandleEnterKey(e)}
                              />
                              <p className="error-text" id="ssn-error">
                                {ssnError && t(ssnError)}
                              </p>
                            </Form.Group> 
                                </Col>
                              </Form.Row>                   
                    
                              <p style={{marginBottom:`10px`}}> {t("pages.idVerification.addressHead")}</p>
                              <div className="separator" style={{marginBottom:`20px`}}></div> 
                    <Form.Row>
                        <Col lg={{ span: 6 }}>
                                  
                    <Form.Group controlId="Address1">
                      <Form.Label>
                        {t("pages.identity.verifyWithDL.address1")}
                      </Form.Label>
                      <Form.Control
                        maxLength={40}
                        value={address1}
                        placeholder={t("pages.idVerification.street1")}
                        onChange={(e) => {
                          this.onAddressHandler(
                            e,
                            "address1"
                          );
                        }}
                        className={
                                  addressOneError
                                    ? "error-field"
                                    : ""
                        }
                        onBlur={(e) => {
                          this.isFormFieldValid(e, "addressOneError");
                        }}
                        aria-required
                        aria-invalid={!!addressOneError}
                        aria-describedby="address-error"
                      />
                      <p className="error-text" id="address-error">
                          {addressOneError && t(addressOneError)}
                      </p>
                  </Form.Group> 
                        </Col>
                        <Col lg={{ span: 6 }}>
                        <Form.Group controlId="Address2">
                    <Form.Label>
                      {t("pages.identity.verifyWithDL.address2")}
                    </Form.Label>
                    <Form.Control
                      maxLength={40}
                      value={address2}
                      placeholder={t("pages.idVerification.street2")}
                      onChange={(e) => {
                        this.onAddressHandler(
                          e,
                          "address2"
                        );
                      }}
                    />                      
                      <p className="error-text" id="address-two-error">
                          {addressTwoError && t(addressTwoError)}
                      </p>
                  </Form.Group>
                        </Col>
                    </Form.Row> 
                    <p className="mobile-style"></p> 
                    <Form.Row>
                      <Col lg={{ span: 6 }}>
                      <Form.Group controlId="city">
                      <Form.Label>{t("pages.idVerification.city")}</Form.Label>
                      <Form.Control
                        value={city}
                        placeholder=""
                        maxLength={50}
                        onChange={(e) => {
                          this.onAddressHandler(
                            e,
                            "city"
                          );
                        }}
                        onBlur={(e) => {
                          this.isFormFieldValid(e, "cityError");
                        }} 
                        aria-required
                        aria-invalid={!!cityError}
                        className={
                                  cityError
                                    ? "error-field"
                                    : ""
                        }
                        aria-describedby="city-error"
                      />
                      <p className="error-text" id="city-error">
                                {cityError && t(cityError)}
                              </p>
                  </Form.Group>  </Col>
                  <Col lg={{ span: 6 }}> <Form.Group controlId="zipCode">
                      <Form.Label>{t("pages.identity.verifyWithSSN.zipCode")}</Form.Label>
                      <Form.Control
                        value={zipCode}
                        placeholder=""
                        minLength={5}
                        maxLength={7}
                        onChange={(e) => {
                          this.onAddressHandler(
                            e,
                            "zipCode"
                          );
                        }}                      
                        onBlur={(e) => {
                          this.isFormFieldValid(e, "zipError");
                        }}
                        aria-required
                        aria-invalid={!!zipError}
                        className={
                                  zipError
                                    ? "error-field"
                                    : ""
                        }
                        aria-describedby="zip-error"
                      />
                      <p className="error-text" id="zip-error">
                                {zipError && t(zipError)}
                              </p>
                  </Form.Group>  </Col>
                  </Form.Row>
                  <Form.Row>
                  <Col lg={{ span: 6 }}> <Form.Group controlId="country">
                      <Form.Label>{t("pages.idVerification.country")} </Form.Label>
                        <Select
                          isDisabled={true}
                          defaultValue={cityOptions[0]} 
                          options={cityOptions}
                          styles={selectStyle}                            
                          aria-required
                          aria-label="select country"
                          aria-invalid={!!countryError}
                          inputId="country"
                          className={
                                  countryError
                                    ? "error-field select-form country-dropdown"
                                    : "select-form country-dropdown"
                          }
                          aria-describedby="country-error"
                      />                        
                      <p className="error-text" id="country-error">
                                {countryError && t(countryError)}
                              </p>
                  </Form.Group>  </Col>
                        <Col lg={{ span: 6 }}><Form.Group controlId="state">
                      <Form.Label>{t("pages.idVerification.state")}</Form.Label>

                      <Select
                          value={states}
                          defaultValue={states}
                          onChange={(e) => { this.onStateHandler(e,"states");}}
                          options={stateOptions}
                          onFocus={(e) => {this.handleFocus(e)}}
                          className={
                                  stateError
                                    ? "error-field select-form"
                                    : "select-form"
                          }
                          styles={selectStyle} 
                          inputId="state"
                          aria-required
                          aria-label="select state"
                          aria-invalid={!!stateError}
                          aria-describedby="state-error"
                      />
                      <p className="error-text" id="state-error">
                        {stateError && t(stateError)}
                      </p>
                  </Form.Group> </Col>
                    </Form.Row>  
                  
                  <div className="pref-language">
                              {t("pages.registration.preferredLanguage")}
                              </div>
                              <Form.Row>
                                <Col lg={{ span: 12 }}>
                                  <Select
                                      key={selectedOption}
                                      defaultValue={defaultOption}
                                      onChange={(e) => this.handleLanguageChange(e)}
                                      options={langOptions}
                                      className="language-selector"
                                      styles={selectStyle} 
                                      aria-required
                                      aria-label="select Language"
                                  />
                                </Col>
                              </Form.Row>       
                      <Form.Row>
                        <Col lg={{ span: 12 }}>
                          {!disableCaptcha && (
                          <div className="google-captcha">
                            <div className="google-captcha__box">
                              {googleCaptchaToken && (
                                <GoogleCaptcha
                                  sitekey={googleCaptchaToken}
                                  onCaptchaChange={this.onCaptchaChange}
                                  captchaReset={captchaReset}
                                />
                              )}
                            </div>
                          </div>
                          )}
                        </Col>
                      </Form.Row>                     
                              <Button
                                className="wrapper__container-card-body-submit"
                                size="lg"
                                variant="primary"
                                disabled={regButton}
                                block
                                type="submit"
                                onClick={(e) => this.onRegister(e)}
                                onKeyDown={(e) => 
                                  {
                                    if(e.key === 'Enter') {
                                      this.onRegister(e)
                                    }
                                  }}
                                role="button"
                                aria-label={t("pages.identity.continue")}
                              >
                                {t("pages.identity.continue")}
                                <img src={RightArrow} alt="" />
                              </Button>
                            </Form>
                            <Button
                                className="wrapper__container-card-body-submit"
                                size="lg"
                                variant="primary"
                                block
                                type="submit"  
                                aria-label={t("pages.profile.cancel")}
                                  onClick={this.displayClosePopup} 
                            >
                                {t("pages.profile.cancel")}
                            </Button>
                          </div>
                        </div>
                      </Col>
                  )}
                  {screen === 3 && (
                  <Col lg={{ span: 6 }} className="next-container">
                  <div className="wrapper__container-card">
                    <div className="wrapper__container-card-body">
                    <h2 className="wrapper__container-card-body-title">{t("pages.idVerification.additionalInfo")}</h2>
                    <div className="box-card">
                    <div className="popup__wrapper-body-pleasenote" style={{borderRadius: `0`}}>
                        <span className="popup__wrapper-body-pleasenote-sp">{t("pages.idVerification.additionalDetails")}</span>
                    </div>
                    </div>
                    <Button
                      className="wrapper__container-card-body-submit"
                      size="lg"
                      variant="primary"
                      block
                      role="button"
                      type="submit"
                      onClick={(e) =>this.getLinkData(e)}
                      aria-label={t("pages.identity.continue")}
                    >
                      {t("pages.identity.continue")}
                      <img src={RightArrow} alt="" />
                    </Button>
                    <Button
                      className="wrapper__container-card-body-submit"
                      size="lg"
                      variant="primary"
                      block
                      type="submit"
                      role="button"
                      aria-label={t("pages.profile.cancel")}
                      onClick={this.displayClosePopup} 
                    >
                      {t("pages.profile.cancel")}
                    </Button>
                  </div>
                  </div>
                  </Col>
                  )}    
                  {screen === 4 && (
                      <Col lg={{ span: 6 }} className="next-container step-screen">
                      <div className="wrapper__container-card">
                        <div className="wrapper__container-card-body">
                      <h1 className="wrapper__container-card-body-title mock-content">
                      {t("pages.idVerification.partTwo.subHead")}
                      </h1>
                      <p>{t("pages.idVerification.partTwo.content")}</p>
                      <div className="image-text">
                          <div className="left">                                    
                          <img src={Card} alt="id-card" className="image-text_image"/>
                          <p style={{textAlign:`center`,marginTop: `10px`, fontWeight: `bold`}}>{t("pages.idVerification.partTwo.bulletOne")}</p>
                          </div>
                          <div className="right">                                    
                          <img src={Phone} alt="mobile" className="image-text_image"/>
                          <p style={{textAlign:`center`, fontWeight: `bold`, marginTop: `8px`}}>{t("pages.idVerification.partTwo.bulletTwo")}</p>  
                          </div>
                        </div>
                        <p style={{clear:`both`, marginBottom: `20px`}}></p>                            
                        <div className="separator"></div>
                        <p className="wrapper__container-card-body-title mock-content"
                            style={{lineHeight:`18px`, fontSize: `18px`, paddingTop:`20px`}}>
                                    {t("pages.idVerification.confirmBelow")}
                            </p>
                            <Checkbox
                                name="consent"
                                ariaLabel={t("pages.idVerification.partTwo.confirmTwo")}
                                label={t("pages.idVerification.partTwo.confirmTwo")}
                                labelAlignment="right"
                                isChecked={consent}
                                handleChange={this.handleConsent}
                                />         
                            <Button
                                className="wrapper__container-card-body-submit"
                                size="lg"
                                variant="primary"
                                block
                                type="submit"    
                                disabled={!consent}                                
                                onClick={(e) =>this.generateQRCode(e)}
                                style={{marginBottom:`10px`}}
                                aria-label={t("pages.idVerification.nextStep")}  
                                >
                                  {t("pages.idVerification.nextStep")}                                     
                                  <img src={RightArrow} alt="" />
                            </Button>
                              <Button
                                className="wrapper__container-card-link"
                                size="lg"
                                variant="primary"
                                block
                                type="submit"  
                                aria-label={t("pages.idVerification.notRequired")}
                                  onClick={(e) => this.toFetchQna(e)} 
                            >
                                {t("pages.idVerification.notRequired")}
                            </Button>
                    </div>
                    </div>
                    </Col>
                  )} 
                  {screen === 5 && (
                    <Col lg={{ span: 6 }} className="next-container">
                    <div className="wrapper__container-card">
                      <div className="wrapper__container-card-body">
                          <h2 className="wrapper__container-card-body-title"
                          style={{marginTop:`60px`, fontSize: `26px`, textAlign:`center`, marginBottom:`0`}}
                          >{t("pages.idVerification.partFour.subHead")}</h2>
                          <Tab.Container id="left-tabs-example" defaultActiveKey="QR" onSelect={this.handleTabChange}>
                              <Row>
                                <Col sm={12}>
                                  <Nav variant="pills" className="justify-content-center">
                                    <Nav.Item>
                                      <Nav.Link eventKey="QR" style={{fontSize: `20px`}}>QR</Nav.Link>
                                    </Nav.Item>
                                    <Nav.Item>
                                      <Nav.Link eventKey="SMS"  style={{fontSize: `20px`}}>SMS</Nav.Link>
                                    </Nav.Item>
                                  </Nav>
                                </Col>
                                <Col sm={12}>
                                  <Tab.Content>
                                    <Tab.Pane eventKey="SMS">
                                        <p style={{textAlign: `center`, fontWeight:`bold`, fontSize: `16px`, marginTop: `40px`, marginBottom: `10px`}}>{t("pages.idVerification.partFour.contentB")}</p>
                                        <ol>
                                          <li>{t("pages.idVerification.partFour.bulletFive")}</li>
                                          <li>{t("pages.idVerification.partFour.bulletSix")}</li>
                                          <li>{t("pages.idVerification.partFour.bulletSeven")}</li>
                                        </ol>
                                        <p style={{textAlign: `center`, fontSize: `13px`, marginBottom: `10px`, marginTop : `10px`}}>{t("pages.idVerification.partFour.contentC")}</p>
                                        <Form style={{width: `250px`, margin: `0 auto`}}>
                                          <Form.Group>
                                            <PhoneInput
                                                  country={'us'}
                                                  placeholder={
                                                    !numberFocus ? "(###) ###-####" : ""
                                                  }
                                                  onlyCountries={['us']}
                                                  disableDropdown={true}
                                                  value={mobileNo}
                                                  className={
                                                    telephoneNumberError ? "error-input" : undefined
                                                  }
                                                  onChange={this.onMobileNumberChange}
                                                  countryCodeEditable={false}
                                                  onFocus={() => {
                                                      this.setState({
                                                        numberFocus: true
                                                      });
                                                    }}
                                                  onBlur={(e) => {
                                                      this.isFormFieldValid(e, "phoneError");
                                                    }}
                                                  inputProps={{
                                                      name: 'phone',
                                                      required: true,
                                                      autoComplete: 'tel',
                                                      'aria-labelledby': 'mobileInfo',
                                                      'aria-describedby': 'mobileInfo mobile-number-error',
                                                      'aria-invalid': !!telephoneNumberError,
                                                    }}
                                              />
                                            <p id="mobileInfo" style={{textAlign:`center`, marginTop: `5px`, fontSize: `11px`}}>{t("pages.idVerification.partFour.contentD")}</p>
                                            <p className="error-text" id="mobile-number-error">
                                              {telephoneNumberError && t(telephoneNumberError)}
                                            </p>
                                          </Form.Group>
                                        <Button
                                          className="wrapper__container-card-body-submit btn-sms"
                                          size="lg"
                                          variant="primary"
                                          block
                                          type="submit"
                                          disabled={disableSMSButton}
                                          style={{width:`250px`, margin: `0 auto`, marginBottom: `20px`}}
                                          onClick={(e) => this.generateSMS(e)}     
                                          aria-label={
                                            smsSent ? 
                                            t("pages.idVerification.partFour.resend")
                                            : t("pages.idVerification.partFour.contentE")
                                          }
                                          onKeyDown={(e) => 
                                            {
                                              if(e.key === 'Enter') {
                                                this.generateSMS(e)
                                              }
                                            }} 
                                        >                                            
                                          {
                                          smsSent ? 
                                          t("pages.idVerification.partFour.resend")
                                          : t("pages.idVerification.partFour.contentE")
                                          }                      
                                          <img src={RightArrow} alt="" />
                                        </Button>
                                        </Form>
                                        {
                                          smsSent &&
                                          <Button
                                          className="wrapper__container-card-body-submit btn-sms"
                                          size="lg"
                                          variant="primary"
                                          block
                                          type="submit"
                                          style={{width:`250px`, margin: `0 auto`, marginBottom: `20px`}}
                                          onClick={(e) => this.pollingAPI(e)}
                                          aria-label={t("pages.identity.continue")}
                                        >                                            
                                          {t("pages.identity.continue")}               
                                          <img src={RightArrow} alt="" />
                                        </Button>
                                        }
                                        <Button
                                          className="wrapper__container-card-link"
                                          size="lg"
                                          variant="primary"
                                          block
                                          type="submit"
                                          role="button"
                                          aria-label={t("pages.profile.cancel")}
                                          onClick={this.displayClosePopup} 
                                        >
                                          {t("pages.profile.cancel")}
                                        </Button>
                                    </Tab.Pane>
                                    <Tab.Pane eventKey="QR">
                                        <div className="qr-content">                        
                                            <p style={{textAlign: `center`, fontWeight:`bold`, fontSize: `16px`, marginTop: `20px`, marginBottom: `20px`}}>{t("pages.idVerification.partFour.contentF")}</p>
                                            <ol>
                                              <li>{t("pages.idVerification.partFour.bulletOne")}</li>
                                              <li>{t("pages.idVerification.partFour.bulletTwo")}</li>
                                              <li>{t("pages.idVerification.partFour.bulletThree")}</li>
                                            </ol>
                                            <div style={{boxShadow:`1px 1px 14px 6px rgba(0, 0, 0, 0.25)`, width: `170px`, margin: `0 auto`, marginTop: `10px`, display: `flex`}}>
                                              <QRCode value={QRLink} className="desktop" size={170} style={{padding:`5px`}}/></div>
                                        </div>                                     
                                        <Button
                                          className="wrapper__container-card-body-submit"
                                          size="lg"
                                          variant="primary"
                                          block
                                          type="submit"
                                          style={{width:`250px`, margin: `0 auto`, marginTop: `20px`}}
                                          onClick={(e) => this.pollingAPI(e)}
                                          onKeyPress={(e) => this.pollingAPI(e)}
                                          aria-label={t("pages.identity.continue")}
                                        >
                                          {t("pages.identity.continue")}
                                          <img src={RightArrow} alt="" />
                                        </Button> 
                                        <Button
                                          className="wrapper__container-card-body-submit"
                                          size="lg"
                                          variant="primary"
                                          block
                                          type="submit"
                                          role="button"
                                          style={{width:`250px`, margin: `0 auto`, marginTop: `20px`}}
                                          aria-label={t("pages.profile.cancel")}
                                          onClick={this.displayClosePopup} 
                                        >
                                          {t("pages.profile.cancel")}
                                        </Button>   
                                          
                      <div>                         
                    </div>
                                    </Tab.Pane>
                                  </Tab.Content>
                                </Col>
                              </Row>
                            </Tab.Container>
                  </div>
                  </div>  
                  </Col>
                  )} 
                  {screen === 6 && (
                    <Col lg={{ span: 6 }} className="next-container">
                    <div className="wrapper__container-card">
                      <div className="wrapper__container-card-body">
                        <h1 className="wrapper__container-card-body-title"
                        style={{marginTop:`60px`, fontSize: `22px`, marginBottom:`0`}}
                        >{t("pages.idVerification.processInfo")}</h1>
                        <p className="context" style={{marginTop: `0`, fontStyle: `normal`, fontSize: `14px`}}>
                        {t("pages.idVerification.partFour.contentOne")}
                        </p>
                        <img className="loading" src={Loading} alt=""/>
                        {documentContent}
                      </div>
                      <Button
                        className="wrapper__container-card-body-submit"
                        size="lg"
                        variant="primary"
                        block
                        type="submit"
                        role="button"
                        style={{width:`250px`, margin: `0 auto`, marginTop: `20px`}}
                        aria-label={t("pages.profile.cancel")}
                        onClick={this.displayClosePopup} 
                      >
                        {t("pages.profile.cancel")}
                        </Button>
                  </div>
                  </Col>
                  )} 
                  {screen === 7 && (
                        <Col lg={{ span: 6 }} className="next-container">
                        <div className="wrapper__container-card">
                          <div className="wrapper__container-card-body">
                        <div className="image-text"  style={{marginTop:`120px`,}}>
                            <div clasName="right" style={{padding: 0}}>
                              <h1 className="wrapper__container-card-body-title" style={{ textAlign: `center`}}>{t("pages.idVerification.idSuccess")}</h1>
                              <p style={{textAlign:`center`, marginBottom:`0`}}
                                >{t("pages.idVerification.identitySuccess")}</p>
                              <img src={tickImage[0].image} alt="" style={{width:`66px`, margin: `0 auto`, display: 'block'}}/>  
                            </div>
                            <Button
                              className="wrapper__container-card-body-submit"
                              size="lg"
                              variant="primary"
                              block
                              type="submit"
                              aria-label= {t("pages.identity.continue")}
                              onClick={this.reloadPage}
                            >
                                {t("pages.identity.continue")}
                                <img src={RightArrow} alt="" />
                            </Button>
                        </div>
                    </div>
                    </div>
                    </Col>
                  )} 
                  {screen === 8 && (
                  <Col lg={{ span: 6 }} className="next-container">
                  <div className="wrapper__container-card">
                    <div className="wrapper__container-card-body">
                <div className="image-text"  style={{marginTop:`120px`,}}>
                    <div clasName="right" style={{padding: 0}}>
                      <h1 className="wrapper__container-card-body-title" style={{ textAlign: `center`}}>{t("pages.idVerification.idFailure")}</h1>
                      {
                          rejectStatus ? 
                            
                          <p style={{textAlign: `center`, marginLeft: `34px`, marginBottom:`0`}}
                          >{t("pages.idVerification.identityDocFailure")}</p>
                          :
                          <p style={{textAlign: `center`, marginBottom:`0`}}
                          >{t("pages.idVerification.identityFailure")}</p>
                        }
                        <img src={tickImage[1].image} alt="" style={{width:`66px`, margin: `0 auto`, display: 'block'}}/> 
                      </div>
                      <Button
                        className="wrapper__container-card-body-submit"
                        size="lg"
                        variant="primary"
                        block
                        type="submit"
                        onClick={this.reloadPage}
                        aria-label={t("pages.identity.continue")}
                      >
                        {t("pages.identity.continue")}
                        <img src={RightArrow} alt="" />
                      </Button>
                </div>
            </div>
            </div>
                  </Col>
                  )} 
                  {screen === 10 && (
                  <Col lg={{ span: 6 }} className="next-container">
                  <div className="wrapper__container-card">
                    <div className="wrapper__container-card-body">
                      <div className="qna-session">
                        <h1>  {t("pages.idVerification.qnaHead")}</h1>
                        <p>  {t("pages.idVerification.qnaContent")}</p>
                        {
                          questionsArray.map((question, index) => 
                            <div className={`question-${index} questions`}>
                            <p>
                              <span>{`${index+1}`}.</span>
                              {question.Text.Statement}
                            </p>
                            <div onChange={this.onOptionsChange} className={`${question.QuestionId}`}>
                              {
                                question.Choices.map(choice =>
                                  <label>
                                    <input
                                        type="radio"
                                        key={choice.ChoiceId}
                                        value={choice.ChoiceId}
                                        name={`${question.QuestionId}`}
                                        aria-required
                                        aria-label= "Select Question"
                                      />
                                      {choice.Text.Statement}
                                  </label>
                                )
                              }  
                            </div>
                            </div>
                          )
                        }
                          <p className="error-text clear-both">
                            {radioError && t(radioError)}
                          </p>
                          <Button
                            className="wrapper__container-card-body-submit qna-submit"
                            size="lg"
                            variant="primary"
                            block
                            type="submit"
                            aria-label={t("pages.identity.continue")}
                            onClick={(e) => this.submitQna(e)}
                            onKeyDown={(e) => 
                                  {
                                    if(e.key === 'Enter') {
                                      this.submitQna(e)
                                    }
                                  }}
                          >
                              {t("pages.identity.continue")}
                              <img src={RightArrow} alt="" />
                          </Button>
                          <Button
                            className="wrapper__container-card-body-submit"
                            size="lg"
                            variant="primary"
                            block
                            type="submit"
                            role="button"
                            aria-label={t("pages.profile.cancel")}
                            onClick={this.displayClosePopup} 
                          >
                            {t("pages.profile.cancel")}
                          </Button>
                      </div>
                  </div>
                  </div>
                  </Col>
                  )} 
                  {screen === 11 && (
                        <Col lg={{ span: 6 }} className="next-container">
                        <div className="wrapper__container-card">
                          <div className="wrapper__container-card-body">
                        <div className="image-text"  style={{marginTop:`120px`,}}>
                            <div clasName="right" style={{padding: 0}}>
                              <h1 className="wrapper__container-card-body-title" style={{ textAlign: `center`}}>{t("pages.pageNotFound.title")}</h1>
                              {
                                  startTransaction 
                                  ?
                                  (<p style={{textAlign:`center`, width: `90%`, margin: `0 auto`, marginBottom:`0`}}
                                >{t("pages.idVerification.internalFailure")}</p>)
                                :
                                (<p style={{textAlign:`center`, width: `90%`, margin: `0 auto`, marginBottom:`0`}}
                                >{t("pages.idVerification.failureKBA")}</p>)
                              }
                              <img src={tickImage[1].image} alt="" style={{width:`66px`, margin: `0 auto`, display: 'block'}}/>  
                            </div>
                            <Button
                              className="wrapper__container-card-body-submit"
                              size="lg"
                              variant="primary"
                              block
                              type="submit"
                              aria-label= {t("pages.idVerification.retry")}
                              onClick={this.reloadPage}
                            >
                                {t("pages.idVerification.retry")}
                                <img src={RightArrow} alt="" />
                            </Button>
                        </div>
                    </div>
                    </div>
                    </Col>
                  )} 
                {screen === 12 && (
                        <Col lg={{ span: 6 }} className="next-container">
                          <div role="alert" aria-live="assertive" className="support-container">   
                              <div clasName="right" style={{padding: 0}}>
                              <h1 className="wrapper__container-card-body-title" style={{ textAlign: `center`}}>{t("pages.pageNotFound.title")}</h1>
                              <img src={tickImage[1].image} alt="" style={{width:`66px`, margin: `0 auto`, display: 'block'}}/> 
                              <p>{t("pages.idVerification.supportContent")}</p>
                              <p>{t("pages.idVerification.supportText")}</p> 
                                {htmlError && htmlError.map((item, index) => (
                                    <p key={index}>{item}</p>
                                  ))}
                              </div>
                          </div>
                    </Col>
                  )} 
                </>   
                  {(rightScreen === 2 || rightScreen === 3 ||  rightScreen > 6) && (
                <Col lg={{ span: 6 }} className="register-right-content">    
                  <div className="register__right-container">                      
                  <div className="register__right-container-heading ">{t("pages.idVerification.rightHead")} </div>
                    <div className={seeMore ? "show" : ""}>
                        <p>{t("pages.idVerification.rightContent")}</p>
                        <div className="hide">
                            <p>{t("pages.idVerification.rightContentOne")}</p>
                            <p><a className="register__right-container-link" tabIndex={0} role="link" aria-label={t("pages.idVerification.rightLink")} href="https://portal.ct.gov/ctidentity/id-verification-faq?language=en_US" target="_blank">{t("pages.idVerification.rightLink")}</a></p> 
                        </div>                          
                        </div>
                      <p
                        className={
                          seeMore ? "open see-more mt-3" : "see-more mt-3"
                        }
                        aria-label=""
                        tabIndex={0}
                        role="button"
                        onClick={this.seeMoreHandler}
                        onKeyPress={this.seeMoreHandler}
                      >
                        <span className="more">{t("pages.login.seeMore")}</span>
                        <span className="less">{t("pages.login.seeLess")}</span>
                        <img src={downChevron} alt="down-chevron"></img>
                      </p>
                  </div>
                </Col>
                )} 
                {rightScreen === 4 && (
                <Col lg={{ span: 6 }} className="register-right-content">    
                  <div className="register__right-container position_center">
                    <p> {t("pages.idVerification.stepOne")}</p>
                    <div className="register__right-container-heading ">{t("pages.idVerification.confirmItem")}</div>
                    </div>
                </Col>
                )} 
                {(rightScreen === 5) && (
                <Col lg={{ span: 6}} className="register-right-content">    
                  <div className="register__right-container position_center">
                    <p>{t("pages.idVerification.stepTwo")}</p>
                    <div className="register__right-container-heading ">{t("pages.idVerification.letsStart")}</div>
                    </div>
                </Col>
                )} 
                {(rightScreen === 6) && (
                <Col lg={{ span: 6 }} className="register-right-content">    
                  <div className="register__right-container position_center">
                    <p>{t("pages.idVerification.stepThree")}</p>
                    <div className="register__right-container-heading ">{t("pages.idVerification.submission")}</div>
                    </div>
                </Col>
                )}                
              </Row>
              {
                showPopup &&
                  <Modal
                    show
                    animation={false}
                    onHide={this.handleClosePopup}
                    onEscapeKeyDown={this.handleClosePopup}
                    backdrop={true}
                    aria-labelledby="mobile-modal"
                  >
                  <Container className="idle-modal">
                      <div className="modal-header">
                      <img className="header__logo" src={Logo} alt="Connecticut" /> 
                          <h2>{t("pages.idVerification.popupHeader")}</h2>
                      </div>
                      <div className="modal-body">
                          <p>{t("pages.idVerification.popupBody")}</p>
                      </div>
                      <div className="modal-footer">
                        <Button className="link" aria-label={t("pages.idVerification.popupLink")} onClick={this.handleClosePopup}>
                        {t("pages.idVerification.popupLink")}<span className="arrow">&gt;</span>
                        </Button>
                      </div>
                  </Container>
                </Modal>
              }
              {
                showCancelPopup &&
                <Modal
                    show
                    animation={false}
                    onHide={this.hideClosePopup}
                    onEscapeKeyDown={this.hideClosePopup}
                    backdrop={true}
                    aria-labelledby="mobile-modal"
                  >
                  <Container className="idle-modal cancel-modal">
                      <div className="modal-header">
                            <img className="header__logo" src={Logo} alt="Connecticut" /> 
                            <h2>{t("pages.idVerification.cancelVerification")}?</h2>
                      </div>
                      <div className="modal-body">
                          <p>{t("pages.idVerification.confirmCancel")}</p>
                          <p>{t("pages.idVerification.progress")}</p>
                      </div>
                      <div className="modal-footer">
                           <Button
                                className="wrapper__container-card-body-submit"
                                size="lg"
                                variant="primary"
                                block
                                type="submit"  
                                aria-label={t("pages.idVerification.cancelVerification")}
                                onClick={this.redirectOnCancel} 
                            >
                                {t("pages.idVerification.cancelVerification")}
                            </Button>
                            <Button
                                className="wrapper__container-card-body-submit"
                                size="lg"
                                variant="primary"
                                block
                                type="submit"  
                                aria-label={t("pages.idVerification.continueVerification")}
                                onClick={this.hideClosePopup} 
                            >
                                {t("pages.idVerification.continueVerification")}<span className="arrow">&gt;</span>
                            </Button>
                      </div>
                  </Container>
                </Modal>
              }
                    </Container>
                  </div>
                  </div>
             )}
        </>
        )
    }
}

export default withTranslation()(IdVerification);